var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 352.49 322.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-101,.cls-104,.cls-155,.cls-156,.cls-161,.cls-162,.cls-163,.cls-164,.cls-178,.cls-180,.cls-194,.cls-2,.cls-20,.cls-205,.cls-207,.cls-208,.cls-210,.cls-211,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-220,.cls-221,.cls-222,.cls-223,.cls-227,.cls-228,.cls-229,.cls-231,.cls-232,.cls-234,.cls-24,.cls-264,.cls-27,.cls-278,.cls-279,.cls-280,.cls-29,.cls-32,.cls-35,.cls-39,.cls-42,.cls-46,.cls-50,.cls-54,.cls-58,.cls-61,.cls-64,.cls-68,.cls-70,.cls-73,.cls-75,.cls-78,.cls-81,.cls-84,.cls-87,.cls-90,.cls-94,.cls-97{mix-blend-mode:color-dodge;}.cls-2{fill:url(#linear-gradient);}.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-198,.cls-203,.cls-3{mix-blend-mode:screen;}.cls-4{fill:#1f6967;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}.cls-17,.cls-171,.cls-172{fill:#45108a;}.cls-102,.cls-124,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-154,.cls-175,.cls-18,.cls-195,.cls-196,.cls-45,.cls-47,.cls-59,.cls-91,.cls-92{mix-blend-mode:multiply;}.cls-18{opacity:0.1;}.cls-19{fill:url(#New_Gradient_Swatch_copy_23);}.cls-20{fill:url(#radial-gradient);}.cls-21{fill:url(#radial-gradient-2);}.cls-22{fill:url(#radial-gradient-3);}.cls-23{fill:url(#New_Gradient_Swatch_copy_23-2);}.cls-24{fill:url(#radial-gradient-4);}.cls-25{fill:url(#radial-gradient-5);}.cls-26{fill:url(#New_Gradient_Swatch_copy_23-3);}.cls-27{fill:url(#New_Gradient_Swatch_copy_32);}.cls-28{fill:url(#New_Gradient_Swatch_copy_23-4);}.cls-29{fill:url(#radial-gradient-6);}.cls-30{fill:url(#radial-gradient-7);}.cls-31{fill:url(#New_Gradient_Swatch_copy_23-5);}.cls-32{fill:url(#New_Gradient_Swatch_copy_32-2);}.cls-33{fill:url(#radial-gradient-8);}.cls-34{fill:url(#New_Gradient_Swatch_copy_23-6);}.cls-35{fill:url(#radial-gradient-9);}.cls-36{fill:url(#radial-gradient-10);}.cls-37{fill:url(#New_Gradient_Swatch_copy_23-7);}.cls-38{fill:url(#radial-gradient-11);}.cls-39{fill:url(#radial-gradient-12);}.cls-40{fill:url(#radial-gradient-13);}.cls-41{fill:url(#New_Gradient_Swatch_copy_23-8);}.cls-42{fill:url(#radial-gradient-14);}.cls-43{fill:url(#linear-gradient-14);}.cls-44{fill:url(#radial-gradient-15);}.cls-45{fill:url(#linear-gradient-15);}.cls-46{fill:url(#New_Gradient_Swatch_copy_32-3);}.cls-47{fill:url(#linear-gradient-16);}.cls-48{fill:url(#radial-gradient-16);}.cls-49{fill:url(#New_Gradient_Swatch_copy_23-9);}.cls-50{fill:url(#radial-gradient-17);}.cls-51{fill:url(#radial-gradient-18);}.cls-52{fill:url(#radial-gradient-19);}.cls-53{fill:url(#New_Gradient_Swatch_copy_23-10);}.cls-54{fill:url(#radial-gradient-20);}.cls-55{fill:url(#radial-gradient-21);}.cls-56{fill:url(#New_Gradient_Swatch_copy_31);}.cls-57{fill:url(#New_Gradient_Swatch_copy_23-11);}.cls-58{fill:url(#radial-gradient-22);}.cls-59{fill:url(#linear-gradient-17);}.cls-60{fill:url(#New_Gradient_Swatch_copy_23-12);}.cls-61{fill:url(#radial-gradient-23);}.cls-62{fill:url(#radial-gradient-24);}.cls-63{fill:url(#New_Gradient_Swatch_copy_23-13);}.cls-148,.cls-168,.cls-170,.cls-172,.cls-198,.cls-64,.cls-68{opacity:0.5;}.cls-64{fill:url(#radial-gradient-25);}.cls-65{fill:url(#radial-gradient-26);}.cls-66{fill:url(#radial-gradient-27);}.cls-67{fill:url(#New_Gradient_Swatch_copy_23-14);}.cls-68{fill:url(#radial-gradient-28);}.cls-69{fill:url(#New_Gradient_Swatch_copy_23-15);}.cls-70{fill:url(#New_Gradient_Swatch_copy_32-4);}.cls-71{fill:url(#linear-gradient-18);}.cls-72{fill:url(#New_Gradient_Swatch_copy_23-16);}.cls-73{fill:url(#radial-gradient-29);}.cls-74{fill:url(#New_Gradient_Swatch_copy_23-17);}.cls-75{fill:url(#New_Gradient_Swatch_copy_32-5);}.cls-76{fill:url(#linear-gradient-19);}.cls-77{fill:url(#New_Gradient_Swatch_copy_23-18);}.cls-78{fill:url(#radial-gradient-30);}.cls-79{fill:url(#radial-gradient-31);}.cls-80{fill:url(#New_Gradient_Swatch_copy_23-19);}.cls-81{fill:url(#radial-gradient-32);}.cls-82{fill:url(#linear-gradient-20);}.cls-83{fill:url(#radial-gradient-33);}.cls-84{fill:url(#radial-gradient-34);}.cls-85{fill:url(#radial-gradient-35);}.cls-86{fill:url(#New_Gradient_Swatch_copy_23-20);}.cls-87{fill:url(#radial-gradient-36);}.cls-88{fill:url(#radial-gradient-37);}.cls-89{fill:url(#radial-gradient-38);}.cls-90{fill:url(#New_Gradient_Swatch_copy_32-6);}.cls-91{fill:url(#linear-gradient-21);}.cls-92{fill:url(#linear-gradient-22);}.cls-93{fill:url(#New_Gradient_Swatch_copy_23-21);}.cls-94{fill:url(#radial-gradient-39);}.cls-95{fill:url(#radial-gradient-40);}.cls-96{fill:url(#New_Gradient_Swatch_copy_23-22);}.cls-97{fill:url(#radial-gradient-41);}.cls-98{fill:url(#linear-gradient-23);}.cls-99{fill:url(#radial-gradient-42);}.cls-100{fill:url(#New_Gradient_Swatch_copy_23-23);}.cls-101{fill:url(#radial-gradient-43);}.cls-102{fill:url(#linear-gradient-24);}.cls-103{fill:url(#linear-gradient-25);}.cls-104{fill:url(#linear-gradient-26);}.cls-105,.cls-106,.cls-107{opacity:0.9;}.cls-105{fill:url(#linear-gradient-27);}.cls-106{fill:url(#linear-gradient-28);}.cls-107{fill:url(#linear-gradient-29);}.cls-108{fill:url(#linear-gradient-30);}.cls-109{fill:url(#linear-gradient-31);}.cls-110{fill:url(#linear-gradient-32);}.cls-111{fill:url(#linear-gradient-33);}.cls-112{fill:url(#linear-gradient-34);}.cls-113{fill:url(#linear-gradient-35);}.cls-114{fill:url(#linear-gradient-36);}.cls-115{fill:url(#linear-gradient-37);}.cls-116{fill:url(#linear-gradient-38);}.cls-117{fill:url(#linear-gradient-39);}.cls-118{fill:url(#linear-gradient-40);}.cls-119{fill:url(#linear-gradient-41);}.cls-120{fill:url(#linear-gradient-42);}.cls-121{fill:url(#linear-gradient-43);}.cls-122{fill:url(#linear-gradient-44);}.cls-123{fill:url(#linear-gradient-45);}.cls-124{fill:url(#radial-gradient-44);}.cls-125,.cls-137,.cls-169{opacity:0;}.cls-125{fill:url(#linear-gradient-46);}.cls-126,.cls-182{opacity:0.07;}.cls-126{fill:url(#linear-gradient-47);}.cls-127{opacity:0.15;fill:url(#linear-gradient-48);}.cls-128{opacity:0.22;fill:url(#linear-gradient-49);}.cls-129{opacity:0.29;fill:url(#linear-gradient-50);}.cls-130,.cls-145{opacity:0.36;}.cls-130{fill:url(#linear-gradient-51);}.cls-131{opacity:0.44;fill:url(#linear-gradient-52);}.cls-132{opacity:0.51;fill:url(#linear-gradient-53);}.cls-133{opacity:0.58;fill:url(#linear-gradient-54);}.cls-134{opacity:0.65;fill:url(#linear-gradient-55);}.cls-135{opacity:0.73;fill:url(#linear-gradient-56);}.cls-136{opacity:0.8;fill:url(#linear-gradient-57);}.cls-137{fill:url(#linear-gradient-58);}.cls-138{opacity:0.05;fill:url(#linear-gradient-59);}.cls-139{opacity:0.09;fill:url(#linear-gradient-60);}.cls-140{opacity:0.14;fill:url(#linear-gradient-61);}.cls-141{opacity:0.18;fill:url(#linear-gradient-62);}.cls-142{opacity:0.23;fill:url(#linear-gradient-63);}.cls-143{opacity:0.27;fill:url(#linear-gradient-64);}.cls-144{opacity:0.32;fill:url(#linear-gradient-65);}.cls-145{fill:url(#linear-gradient-66);}.cls-146{opacity:0.41;fill:url(#linear-gradient-67);}.cls-147{opacity:0.45;fill:url(#linear-gradient-68);}.cls-148{fill:url(#linear-gradient-69);}.cls-149{fill:url(#radial-gradient-45);}.cls-150{fill:url(#linear-gradient-70);}.cls-151{fill:#2af6ff;}.cls-152{fill:url(#radial-gradient-46);}.cls-153{fill:url(#linear-gradient-71);}.cls-154{fill:url(#radial-gradient-47);}.cls-155{fill:url(#New_Gradient_Swatch_copy);}.cls-156{fill:url(#radial-gradient-48);}.cls-157{fill:url(#linear-gradient-72);}.cls-158{fill:url(#linear-gradient-73);}.cls-159{fill:url(#linear-gradient-74);}.cls-160{fill:url(#radial-gradient-49);}.cls-161{fill:url(#New_Gradient_Swatch_copy-2);}.cls-162{fill:url(#New_Gradient_Swatch_copy_6);}.cls-163{fill:url(#New_Gradient_Swatch_copy_6-2);}.cls-164{fill:url(#radial-gradient-50);}.cls-165{fill:url(#linear-gradient-75);}.cls-166,.cls-167,.cls-168,.cls-169{fill:#7c1dc9;}.cls-166,.cls-171,.cls-173{opacity:0.2;}.cls-174{fill:url(#New_Gradient_Swatch_copy_25);}.cls-175{fill:url(#radial-gradient-51);}.cls-176{fill:url(#New_Gradient_Swatch_copy_14);}.cls-177{fill:url(#radial-gradient-52);}.cls-178{fill:url(#radial-gradient-53);}.cls-179{fill:url(#radial-gradient-54);}.cls-180{fill:url(#New_Gradient_Swatch_copy-3);}.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192{fill:#fff;}.cls-181{opacity:0.05;}.cls-183{opacity:0.1;}.cls-184{opacity:0.12;}.cls-185{opacity:0.14;}.cls-186{opacity:0.16;}.cls-187{opacity:0.19;}.cls-188{opacity:0.21;}.cls-189{opacity:0.23;}.cls-190{opacity:0.25;}.cls-191{opacity:0.28;}.cls-192{opacity:0.3;}.cls-193{fill:url(#New_Gradient_Swatch_copy_25-3);}.cls-194{fill:url(#New_Gradient_Swatch_copy_6-3);}.cls-195,.cls-197{fill:#b086cc;}.cls-199{fill:url(#New_Gradient_Swatch_copy_25-4);}.cls-200{fill:url(#New_Gradient_Swatch_copy_23-24);}.cls-201{fill:url(#New_Gradient_Swatch_copy_25-5);}.cls-202{fill:url(#New_Gradient_Swatch_copy_7);}.cls-203{fill:url(#linear-gradient-76);}.cls-204{fill:url(#New_Gradient_Swatch_copy_25-6);}.cls-205{fill:url(#New_Gradient_Swatch_copy_6-4);}.cls-206{fill:url(#radial-gradient-55);}.cls-207{fill:url(#New_Gradient_Swatch_copy-4);}.cls-208{fill:url(#linear-gradient-77);}.cls-209{fill:url(#linear-gradient-78);}.cls-210{fill:url(#linear-gradient-79);}.cls-211{fill:url(#linear-gradient-80);}.cls-212{fill:url(#linear-gradient-81);}.cls-213{fill:url(#linear-gradient-82);}.cls-214{fill:url(#linear-gradient-83);}.cls-215{fill:url(#linear-gradient-84);}.cls-216{fill:url(#linear-gradient-85);}.cls-217{fill:url(#linear-gradient-86);}.cls-218{fill:url(#linear-gradient-87);}.cls-219{fill:url(#linear-gradient-88);}.cls-220{fill:url(#linear-gradient-89);}.cls-221{fill:url(#linear-gradient-90);}.cls-222{fill:url(#linear-gradient-91);}.cls-223{fill:url(#linear-gradient-92);}.cls-224{fill:url(#linear-gradient-93);}.cls-225{fill:url(#linear-gradient-94);}.cls-226{fill:url(#linear-gradient-95);}.cls-227{fill:url(#linear-gradient-96);}.cls-228{fill:url(#linear-gradient-97);}.cls-229{fill:url(#linear-gradient-98);}.cls-230{fill:url(#linear-gradient-99);}.cls-231{fill:url(#linear-gradient-100);}.cls-232{fill:url(#linear-gradient-101);}.cls-233{fill:url(#linear-gradient-102);}.cls-234{fill:url(#linear-gradient-103);}.cls-235{fill:url(#linear-gradient-104);}.cls-236{fill:url(#linear-gradient-105);}.cls-237{fill:url(#linear-gradient-106);}.cls-238{fill:url(#linear-gradient-107);}.cls-239{fill:url(#linear-gradient-108);}.cls-240{fill:url(#linear-gradient-109);}.cls-241{fill:url(#linear-gradient-110);}.cls-242{fill:url(#linear-gradient-111);}.cls-243{fill:url(#linear-gradient-112);}.cls-244{fill:url(#linear-gradient-113);}.cls-245{fill:url(#linear-gradient-114);}.cls-246{fill:url(#linear-gradient-115);}.cls-247{fill:url(#linear-gradient-116);}.cls-248{fill:url(#linear-gradient-117);}.cls-249{fill:url(#linear-gradient-118);}.cls-250{fill:url(#linear-gradient-119);}.cls-251{fill:url(#linear-gradient-120);}.cls-252{fill:url(#linear-gradient-121);}.cls-253{fill:url(#linear-gradient-122);}.cls-254{fill:url(#linear-gradient-123);}.cls-255{fill:url(#linear-gradient-124);}.cls-256{fill:url(#linear-gradient-125);}.cls-257{fill:url(#linear-gradient-126);}.cls-258{fill:url(#linear-gradient-127);}.cls-259{fill:url(#linear-gradient-128);}.cls-260{fill:url(#linear-gradient-129);}.cls-261{fill:url(#linear-gradient-130);}.cls-262{fill:url(#linear-gradient-131);}.cls-263{fill:url(#linear-gradient-132);}.cls-264{fill:url(#linear-gradient-133);}.cls-265{fill:url(#linear-gradient-134);}.cls-266{fill:url(#linear-gradient-135);}.cls-267{fill:url(#linear-gradient-136);}.cls-268{fill:url(#linear-gradient-137);}.cls-269{fill:url(#linear-gradient-138);}.cls-270{fill:url(#linear-gradient-139);}.cls-271{fill:url(#linear-gradient-140);}.cls-272{fill:url(#linear-gradient-141);}.cls-273{fill:url(#linear-gradient-142);}.cls-274{fill:url(#linear-gradient-143);}.cls-275{fill:url(#linear-gradient-144);}.cls-276{fill:url(#linear-gradient-145);}.cls-277{fill:url(#linear-gradient-146);}.cls-278{fill:url(#linear-gradient-147);}.cls-279{fill:url(#linear-gradient-148);}.cls-280{fill:url(#linear-gradient-149);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 357.81,
    y1: 110.7,
    x2: 271.2,
    y2: 110.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#3ec2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3790a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#32658c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2d4375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2a2864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#271457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26094f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 293.46,
    y1: 127.96,
    x2: 293.46,
    y2: 111.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 312.75,
    y1: 117.47,
    x2: 312.75,
    y2: 93.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 306.32,
    y1: 120.31,
    x2: 306.32,
    y2: 88.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 280.6,
    y1: 141.24,
    x2: 280.6,
    y2: 109.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 299.89,
    y1: 123.76,
    x2: 299.89,
    y2: 103.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 287.03,
    y1: 133.34,
    x2: 287.03,
    y2: 97.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 332.05,
    y1: 111.71,
    x2: 332.05,
    y2: 84.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 351.34,
    y1: 109.19,
    x2: 351.34,
    y2: 82.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 344.91,
    y1: 109.71,
    x2: 344.91,
    y2: 75.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 325.62,
    y1: 113.23,
    x2: 325.62,
    y2: 97.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 319.19,
    y1: 115.14,
    x2: 319.19,
    y2: 79.97,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 338.48,
    y1: 110.53,
    x2: 338.48,
    y2: 72.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23",
    x1: 6259.3,
    y1: 91.1,
    x2: 6245.95,
    y2: 96.1,
    gradientTransform: "matrix(-1, 0.06, 0.06, 1, 6593, -320.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#c8abda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#dac6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f7f2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f9f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e9dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b395d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9c7dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8e6ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9471c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 6402.53,
    cy: 7.44,
    r: 7.74,
    gradientTransform: "matrix(-0.94, 0.06, 0.06, 0.94, 6399.52, -221.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8c276c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#671d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#471437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2d0d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#190713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0b0308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#020102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1079.87,
    cy: 121.74,
    r: 3.04,
    gradientTransform: "translate(-724.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#364f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1b2b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1084.92,
    cy: 157.42,
    r: 2.52,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-2",
    x1: 6395.36,
    y1: 147.29,
    x2: 6386.43,
    y2: 147.22,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 8139.95,
    cy: 147.25,
    r: 7.18,
    gradientTransform: "matrix(-0.6, 0, 0, 1, 5277.6, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 1084.51,
    cy: 137.11,
    r: 3.04,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-3",
    x1: 6399.79,
    y1: 130.97,
    x2: 6389.57,
    y2: 127.98,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_32",
    cx: 9226.03,
    cy: 407.2,
    r: 5.12,
    gradientTransform: "matrix(-0.57, 0, 0.18, 1.19, 5525.39, -381.98)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-4",
    x1: 6420.55,
    y1: 218.21,
    x2: 6418.88,
    y2: 229,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 6420.61,
    cy: 8434.27,
    r: 7.86,
    gradientTransform: "matrix(-1, 0, 0, 0.5, 6751.97, -3995.5)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 1062.03,
    cy: 219.81,
    r: 3.04,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-5",
    x1: 6405.43,
    y1: 211.24,
    x2: 6407.81,
    y2: 222.98,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_32-2",
    cx: 6408.13,
    cy: 213.5,
    r: 3.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 1071.81,
    cy: 213.61,
    r: 3.04,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-6",
    x1: 6411.09,
    y1: 199.5,
    x2: 6400.16,
    y2: 198.16,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 6743.24,
    cy: -2869.11,
    r: 7.76,
    gradientTransform: "matrix(-0.89, 0, 0, 1.6, 6335.03, 4787.81)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 1068.51,
    cy: 184.71,
    r: 4.39,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-7",
    x1: 6416.52,
    y1: 164.3,
    x2: 6400.46,
    y2: 165.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 6454.52,
    cy: 102.29,
    r: 11.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e6d7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d7bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c4a4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#a17bc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a37cc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ae84cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#ad84cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a57dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f79c8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 6458.41,
    cy: 102.98,
    r: 5.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 1020.19,
    cy: 112.42,
    r: 2.52,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-8",
    x1: 6443.83,
    y1: 119.67,
    x2: 6451.32,
    y2: 126.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 7780.8,
    cy: -311.86,
    r: 10.02,
    gradientTransform: "matrix(-0.78, -0.05, -0.04, 0.69, 6386.62, 727.04)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 6420.74,
    y1: 144.61,
    x2: 6400.38,
    y2: 145.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 6424.14,
    cy: 116.86,
    r: 32.64,
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 6408.9,
    y1: 126.86,
    x2: 6404.58,
    y2: 144.4,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_32-3",
    cx: 6417.48,
    cy: 117.25,
    r: 17.32,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 6416.21,
    y1: 142.89,
    x2: 6420.91,
    y2: 130.67,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 6422.88,
    cy: 132.23,
    r: 4.08,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-9",
    x1: 6421.6,
    y1: 206.31,
    x2: 6412.22,
    y2: 204.4,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 7181.53,
    cy: -3793.83,
    r: 7.37,
    gradientTransform: "matrix(-0.74, 0.06, 0.14, 1.9, 6214.2, 7010.59)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 1056.15,
    cy: 190.78,
    r: 3.86,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 1039.81,
    cy: 131.22,
    r: 3.04,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-10",
    x1: 6428.6,
    y1: 126.35,
    x2: 6429.33,
    y2: 137.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 6429.57,
    cy: 5780.51,
    r: 10.14,
    gradientTransform: "matrix(-1, 0, 0, 0.5, 6751.97, -2759.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 6418.29,
    cy: 102.96,
    r: 16.1,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_31",
    cx: 6417.48,
    cy: 98.99,
    r: 15.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e6d7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d7bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c4a4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#a17bc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f79c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-11",
    x1: 6427.23,
    y1: 169.61,
    x2: 6411.27,
    y2: 172.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 6751.97, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 8156.09,
    cy: -1403.86,
    r: 14.45,
    gradientTransform: "matrix(-0.61, -0.01, -0.02, 1.24, 5278.04, 1985.17)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 6410.92,
    y1: 99.47,
    x2: 6411.2,
    y2: 112.56,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-12",
    x1: 4332.28,
    y1: 4794.11,
    x2: 4321.02,
    y2: 4795.75,
    gradientTransform: "matrix(0.21, -0.98, -0.98, -0.21, 4196.32, 5472.57)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 4326.33,
    cy: 4796.9,
    r: 10.12,
    gradientTransform: "matrix(0.21, -0.98, -0.98, -0.21, 4196.32, 5472.57)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 3206.47,
    cy: 4807.45,
    r: 3.43,
    gradientTransform: "matrix(0.54, -0.84, -0.84, -0.54, 2780.08, 5510.51)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-13",
    x1: 6799.01,
    y1: 227.45,
    x2: 6801.08,
    y2: 235.57,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 6903.28,
    cy: -134.5,
    r: 9.17,
    gradientTransform: "matrix(-1, -0.09, -0.06, 0.61, 7317.24, 939.81)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 6369.42,
    cy: -338.15,
    r: 3.01,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, 6746.42, -850.62)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 6107.47,
    cy: -642.53,
    r: 4.66,
    gradientTransform: "matrix(-0.94, 0.34, 0.34, 0.94, 6440.09, -1231.65)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-14",
    x1: 6783.06,
    y1: 224.7,
    x2: 6778.44,
    y2: 232.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 6777.61,
    cy: -717.18,
    r: 8.14,
    gradientTransform: "matrix(-0.94, 0.1, 0.08, 0.71, 6905.72, 28.24)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-15",
    x1: 6778.01,
    y1: 315.84,
    x2: 6759.85,
    y2: 333.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_32-4",
    cx: 6771.69,
    cy: 321.84,
    r: 7.07,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 6766.81,
    y1: 305.95,
    x2: 6761.56,
    y2: 306.28,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-16",
    x1: 6772.92,
    y1: 306.03,
    x2: 6758.92,
    y2: 302.67,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 8590.86,
    cy: -2740.5,
    r: 8.76,
    gradientTransform: "matrix(-0.61, 0.04, 0.1, 1.54, 6019.33, 4179.27)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-17",
    x1: 6763.24,
    y1: 328.46,
    x2: 6746.18,
    y2: 334.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_32-5",
    cx: 6757.95,
    cy: 330.4,
    r: 7.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 6756.56,
    y1: 312.31,
    x2: 6751.64,
    y2: 312.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-18",
    x1: 6759.61,
    y1: 311.59,
    x2: 6745.28,
    y2: 310.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 9717.22,
    cy: -3142.87,
    r: 6.76,
    gradientTransform: "matrix(-0.51, 0.01, 0.03, 1.31, 5544.24, 4301.44)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 6770.66,
    cy: 293.16,
    r: 4.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-19",
    x1: 6776.58,
    y1: 270.82,
    x2: 6757.73,
    y2: 274.21,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 8916.02,
    cy: -2417.95,
    r: 14.27,
    gradientTransform: "matrix(-0.59, 0, 0, 1.48, 5767.45, 3859.65)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 6771.99,
    y1: 253.57,
    x2: 6752.06,
    y2: 255.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 6774.51,
    cy: 228.21,
    r: 37.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 6768.28,
    cy: 239.96,
    r: 14.77,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 6758.01,
    cy: 299.92,
    r: 3.92,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-20",
    x1: 6764.3,
    y1: 277.42,
    x2: 6744.79,
    y2: 279.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 9125.86,
    cy: -1092.81,
    r: 14.03,
    gradientTransform: "matrix(-0.66, 0, 0, 1.2, 6540.54, 1588.29)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 6764.83,
    cy: 208.28,
    r: 16.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 6771.77,
    cy: 205.16,
    r: 20.49,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_32-6",
    cx: 6768.62,
    cy: 208.99,
    r: 7.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 6760.21,
    y1: 236.28,
    x2: 6759.31,
    y2: 253.67,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 6775.27,
    y1: 243.4,
    x2: 6747.22,
    y2: 241.43,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-21",
    x1: 6617.82,
    y1: 189.76,
    x2: 6603.51,
    y2: 195.13,
    gradientTransform: "matrix(-1, 0.06, 0.06, 1, 7091, -320.84)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 6614.4,
    cy: 193.21,
    r: 7.85,
    gradientTransform: "matrix(-1, 0.06, 0.06, 1, 7091, -320.84)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 6778.99,
    cy: 628.28,
    r: 2.9,
    gradientTransform: "matrix(-1, -0.08, -0.08, 1, 7314.13, 210.64)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-22",
    x1: 6782.86,
    y1: 552.24,
    x2: 6771.02,
    y2: 551.27,
    gradientTransform: "matrix(-1, -0.08, -0.08, 0.93, 7305.77, 308.5)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 7729.18,
    cy: -2580.19,
    r: 6.25,
    gradientTransform: "matrix(-0.77, -0.06, -0.12, 1.44, 6133.38, 4471.41)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 6949.64,
    y1: 901.88,
    x2: 6942.77,
    y2: 898.9,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 7490.35, 753.24)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 6328.14,
    cy: -308.79,
    r: 3.01,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, 6746.42, -850.62)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-23",
    x1: 6695.15,
    y1: 306.54,
    x2: 6684.2,
    y2: 303.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 7196, -69.12)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 7571.75,
    cy: 179.72,
    r: 6.49,
    gradientTransform: "matrix(-0.75, 0.05, 0.08, 1.04, 6169.77, -288.07)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 6765.35,
    y1: 209.97,
    x2: 6755.18,
    y2: 211.77,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 6839.06,
    y1: 207.73,
    x2: 6839.06,
    y2: 102.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#36bdb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#288b87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#1c605d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#123e3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0a2321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#040f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 408.81,
    y1: 224.51,
    x2: 494.41,
    y2: 224.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 6798.64,
    y1: 274.51,
    x2: 6800.94,
    y2: 211.22,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 6796.64,
    y1: 213.48,
    x2: 6799.09,
    y2: 251.98,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 6799.27,
    y1: 250.32,
    x2: 6800.16,
    y2: 265.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 7249.98, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 571.17,
    y1: 328.58,
    x2: 571.17,
    y2: 343.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#113a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0a2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#040f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 571.17,
    y1: 328.6,
    x2: 571.17,
    y2: 343.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#164a48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#134140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0b2524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#051010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 571.17,
    y1: 328.62,
    x2: 571.17,
    y2: 343.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a5a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#144645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0b2827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#051211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 571.17,
    y1: 328.64,
    x2: 571.17,
    y2: 342.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f6967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#164c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0d2b2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#061313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#010505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 571.17,
    y1: 328.66,
    x2: 571.17,
    y2: 342.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#237976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#185250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0e2f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#061514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#020505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 571.17,
    y1: 328.68,
    x2: 571.17,
    y2: 342.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#288985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1a5a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0f3332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#071717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#020606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 571.17,
    y1: 328.7,
    x2: 571.17,
    y2: 342.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c9995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1d6462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#103938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#071a19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 571.17,
    y1: 328.72,
    x2: 571.17,
    y2: 342.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31a9a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#21716d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#13403e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#081d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#020808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 571.17,
    y1: 328.73,
    x2: 571.17,
    y2: 341.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35b9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#25807c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#154947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0a2120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#030909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 571.17,
    y1: 328.75,
    x2: 571.17,
    y2: 341.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ac8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2b9591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#195653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0b2726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030b0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 571.17,
    y1: 328.77,
    x2: 571.17,
    y2: 341.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ed8d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#33b3ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1e6764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0e2f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#040d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 571.17,
    y1: 328.79,
    x2: 571.17,
    y2: 341.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#41e1db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#26827e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#113c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#051110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 567.77,
    y1: 326.03,
    x2: 574.57,
    y2: 326.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 551.43,
    y1: 303.87,
    x2: 563.86,
    y2: 305.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 292.8,
    y1: 260.88,
    x2: 298.27,
    y2: 264.04,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 555.24,
    y1: 310,
    x2: 587.05,
    y2: 305.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c8abda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dac6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f7f2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f9f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e9dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b395d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9c7dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8e6ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9471c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 569.69,
    cy: 306.66,
    r: 20.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f4f2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#d8d0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8770b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 283.6,
    y1: 229.1,
    x2: 307.51,
    y2: 242.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e9ddf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b188cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 283.74,
    y1: 229.12,
    x2: 307.36,
    y2: 242.77,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 283.87,
    y1: 229.15,
    x2: 307.21,
    y2: 242.62,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 284.01,
    y1: 229.17,
    x2: 307.06,
    y2: 242.48,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 284.15,
    y1: 229.19,
    x2: 306.91,
    y2: 242.34,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 284.29,
    y1: 229.22,
    x2: 306.76,
    y2: 242.19,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 284.43,
    y1: 229.24,
    x2: 306.62,
    y2: 242.05,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 284.57,
    y1: 229.26,
    x2: 306.47,
    y2: 241.91,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 284.7,
    y1: 229.29,
    x2: 306.32,
    y2: 241.77,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 284.84,
    y1: 229.31,
    x2: 306.17,
    y2: 241.62,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 284.98,
    y1: 229.34,
    x2: 306.02,
    y2: 241.48,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 285.12,
    y1: 229.36,
    x2: 305.87,
    y2: 241.34,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 286.9,
    y1: 227.68,
    x2: 307.64,
    y2: 239.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 287.13,
    y1: 227.85,
    x2: 307.34,
    y2: 239.52,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 287.37,
    y1: 228.03,
    x2: 307.04,
    y2: 239.39,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 287.61,
    y1: 228.2,
    x2: 306.75,
    y2: 239.26,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 287.85,
    y1: 228.38,
    x2: 306.45,
    y2: 239.12,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 288.08,
    y1: 228.56,
    x2: 306.16,
    y2: 238.99,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 563.97,
    y1: 290.81,
    x2: 581.51,
    y2: 300.94,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 564.21,
    y1: 290.99,
    x2: 581.21,
    y2: 300.8,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 288.8,
    y1: 229.09,
    x2: 305.27,
    y2: 238.6,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 564.68,
    y1: 291.34,
    x2: 580.62,
    y2: 300.54,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 564.92,
    y1: 291.52,
    x2: 580.33,
    y2: 300.41,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 289.51,
    y1: 229.62,
    x2: 304.38,
    y2: 238.2,
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 566.57,
    cy: 278.53,
    r: 25.54,
    gradientTransform: "translate(759.15 -325.86) rotate(80.73)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 553.57,
    y1: 284.28,
    x2: 572.63,
    y2: 284.28,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 304.88,
    cy: 244.95,
    r: 6.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6115a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#5a139a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2b0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 577.24,
    y1: 312.99,
    x2: 589.57,
    y2: 314.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 578.52,
    cy: 311.46,
    r: 8.71,
    xlinkHref: "#radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy",
    cx: -6560.21,
    cy: -1885.49,
    r: 5.66,
    gradientTransform: "matrix(0.32, -0.19, 0, 0.98, 2677.81, 884.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8a266a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0f040c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: -8495.89,
    cy: -1828.95,
    r: 5.91,
    gradientTransform: "matrix(0.34, -0.15, -0.12, 0.97, 3267.85, 774.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#220a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0f040c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 565.83,
    y1: 270.09,
    x2: 576.47,
    y2: 270.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 291.25,
    y1: 203.57,
    x2: 299.81,
    y2: 208.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f9f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e8dbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ccb1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 570.38,
    y1: 264.46,
    x2: 571.98,
    y2: 264.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 570.61,
    cy: 260.41,
    r: 3.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy-2",
    cx: 290.14,
    cy: 214.08,
    r: 13.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6",
    cx: 557.91,
    cy: 282.12,
    r: 5.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#34b5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#257f7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#17514f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0d2e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#061514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#020505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6-2",
    cx: 565.81,
    cy: 286.78,
    r: 5.07,
    xlinkHref: "#New_Gradient_Swatch_copy_6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: -4362.94,
    cy: -328.58,
    r: 16.13,
    gradientTransform: "matrix(0.22, -0.06, 0.24, 0.97, 1603.84, 387.38)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -1238.27,
    y1: 6381.59,
    x2: -1233.17,
    y2: 6381.59,
    gradientTransform: "matrix(0.61, 1.06, -0.61, 0.35, 5225.13, -629.43)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25",
    x1: 367.32,
    y1: 238.11,
    x2: 395.16,
    y2: 238.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 394.08,
    cy: 231.05,
    r: 25.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c2db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#764fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a084d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c2b0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#dcd2ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#efebf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fbfafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_14",
    cx: 101.35,
    cy: 173.81,
    r: 19.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#138bbd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 376.16,
    cy: 232.59,
    r: 27.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 101.78,
    cy: 173.05,
    r: 22.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#29eef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#1fb7be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#17868b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#105d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0a3b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#062123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#030f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 366.32,
    cy: 237.75,
    r: 29.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy-3",
    cx: 93.52,
    cy: 173.21,
    r: 14.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-3",
    x1: 301.37,
    y1: 251.23,
    x2: 308.99,
    y2: 238.1,
    gradientTransform: "translate(61.23)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6-3",
    cx: 89.59,
    cy: 184.79,
    r: 4.47,
    xlinkHref: "#New_Gradient_Swatch_copy_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-4",
    x1: 363.01,
    y1: 308.46,
    x2: 398.1,
    y2: 308.46,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_23-24",
    x1: 362.43,
    y1: 306.58,
    x2: 398.67,
    y2: 306.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-5",
    x1: 120.59,
    y1: 211.24,
    x2: 97.63,
    y2: 250.06,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7",
    x1: 119.08,
    y1: 213.34,
    x2: 98.35,
    y2: 248.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1fc3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 380.67,
    y1: 308.4,
    x2: 380.67,
    y2: 289.43,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-6",
    x1: 88.99,
    y1: 239.36,
    x2: 98.37,
    y2: 239.36,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6-4",
    cx: 92.24,
    cy: 240.29,
    r: 4.47,
    xlinkHref: "#New_Gradient_Swatch_copy_6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 378.12,
    cy: 285.54,
    r: 24.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy-4",
    cx: 369.57,
    cy: 287.55,
    r: 14.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 520.23,
    y1: 315.19,
    x2: 567.89,
    y2: 315.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 504.21,
    y1: 284.89,
    x2: 504.21,
    y2: 179.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 7011.92,
    y1: 4401.06,
    x2: 7011.92,
    y2: 4390.99,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 7011.92,
    y1: 4397.55,
    x2: 7011.92,
    y2: 4387.47,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 6991.39,
    y1: 4395.03,
    x2: 6991.39,
    y2: 4389.09,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 6991.39,
    y1: 4398.54,
    x2: 6991.39,
    y2: 4392.6,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 6991.39,
    y1: 4402.05,
    x2: 6991.39,
    y2: 4396.11,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 6991.39,
    y1: 4391.52,
    x2: 6991.39,
    y2: 4385.58,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 6991.39,
    y1: 4388,
    x2: 6991.39,
    y2: 4382.06,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 7011.92,
    y1: 4404.57,
    x2: 7011.92,
    y2: 4394.5,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 7011.92,
    y1: 4408.08,
    x2: 7011.92,
    y2: 4398.01,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 7011.92,
    y1: 4411.59,
    x2: 7011.92,
    y2: 4401.52,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 7011.92,
    y1: 4415.11,
    x2: 7011.92,
    y2: 4405.04,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 7011.92,
    y1: 4429.15,
    x2: 7011.92,
    y2: 4419.08,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 7011.92,
    y1: 4425.64,
    x2: 7011.92,
    y2: 4415.57,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 7011.92,
    y1: 4422.13,
    x2: 7011.92,
    y2: 4412.06,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 7011.92,
    y1: 4418.62,
    x2: 7011.92,
    y2: 4408.55,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 6991.39,
    y1: 4405.56,
    x2: 6991.39,
    y2: 4399.63,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 6991.39,
    y1: 4419.61,
    x2: 6991.39,
    y2: 4413.67,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 6991.39,
    y1: 4416.1,
    x2: 6991.39,
    y2: 4410.16,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 6991.39,
    y1: 4423.12,
    x2: 6991.39,
    y2: 4417.18,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 6991.39,
    y1: 4409.07,
    x2: 6991.39,
    y2: 4403.14,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 6991.39,
    y1: 4412.59,
    x2: 6991.39,
    y2: 4406.65,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 7011.92,
    y1: 4436.17,
    x2: 7011.92,
    y2: 4426.11,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 6991.39,
    y1: 4426.62,
    x2: 6991.39,
    y2: 4420.7,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 7011.92,
    y1: 4432.67,
    x2: 7011.92,
    y2: 4422.6,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 329.55,
    y1: 315.76,
    x2: 377.22,
    y2: 315.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 313.53,
    y1: 279,
    x2: 313.53,
    y2: 173.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 349.61,
    y1: 317.32,
    x2: 370.61,
    y2: 321.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 331.91,
    y1: 311.39,
    x2: 370.91,
    y2: 321.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 333.47,
    y1: 305.31,
    x2: 372.47,
    y2: 315.31,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 335.04,
    y1: 299.17,
    x2: 374.04,
    y2: 309.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 333.99,
    y1: 303.27,
    x2: 372.99,
    y2: 313.27,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 334.51,
    y1: 301.26,
    x2: 373.51,
    y2: 311.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 348.98,
    y1: 320.34,
    x2: 369.98,
    y2: 324.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 347.73,
    y1: 326.43,
    x2: 368.73,
    y2: 330.76,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 333.31,
    y1: 305.93,
    x2: 372.31,
    y2: 315.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 330.3,
    y1: 317.67,
    x2: 369.3,
    y2: 327.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 350.34,
    y1: 313.74,
    x2: 371.34,
    y2: 318.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 334.16,
    y1: 302.61,
    x2: 373.16,
    y2: 312.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 348.17,
    y1: 324.29,
    x2: 369.17,
    y2: 328.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 333.12,
    y1: 306.68,
    x2: 372.12,
    y2: 316.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 334.18,
    y1: 302.54,
    x2: 373.18,
    y2: 312.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 331.64,
    y1: 312.44,
    x2: 370.64,
    y2: 322.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 330.8,
    y1: 315.7,
    x2: 369.8,
    y2: 325.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 332.44,
    y1: 309.32,
    x2: 371.44,
    y2: 319.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 329.98,
    y1: 318.92,
    x2: 368.98,
    y2: 328.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 333.33,
    y1: 305.84,
    x2: 372.33,
    y2: 315.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 332.5,
    y1: 309.08,
    x2: 371.5,
    y2: 319.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 329.13,
    y1: 322.21,
    x2: 368.13,
    y2: 332.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 328.27,
    y1: 325.6,
    x2: 367.27,
    y2: 335.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 330.83,
    y1: 315.58,
    x2: 369.84,
    y2: 325.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 331.44,
    y1: 313.22,
    x2: 370.44,
    y2: 323.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 329.87,
    y1: 319.35,
    x2: 368.87,
    y2: 329.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 328.81,
    y1: 323.48,
    x2: 367.81,
    y2: 333.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 346.79,
    y1: 330.99,
    x2: 367.79,
    y2: 335.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 339.65,
    y1: 258.09,
    x2: 366.8,
    y2: 258.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 323.63,
    y1: 229.27,
    x2: 323.63,
    y2: 124.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 7192.5,
    y1: 4456.68,
    x2: 7192.5,
    y2: 4446.61,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 7192.5,
    y1: 4453.17,
    x2: 7192.5,
    y2: 4443.1,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 7192.5,
    y1: 4460.2,
    x2: 7192.5,
    y2: 4450.12,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 3331.93,
    y1: 3314.8,
    x2: 3311.68,
    y2: 3308.8,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 7192.5,
    y1: 4467.22,
    x2: 7192.5,
    y2: 4457.15,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 3330.02,
    y1: 3321.25,
    x2: 3309.77,
    y2: 3315.25,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 7192.5,
    y1: 4484.78,
    x2: 7192.5,
    y2: 4474.71,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 3327.15,
    y1: 3330.94,
    x2: 3306.9,
    y2: 3324.94,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 7192.5,
    y1: 4477.76,
    x2: 7192.5,
    y2: 4467.68,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 3329.06,
    y1: 3324.48,
    x2: 3308.81,
    y2: 3318.48,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 7192.5,
    y1: 4491.79,
    x2: 7192.5,
    y2: 4481.73,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 7192.5,
    y1: 4488.29,
    x2: 7192.5,
    y2: 4478.22,
    gradientTransform: "translate(7545.5 4725.49) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 293.52,
    y1: 220.14,
    x2: 232.18,
    y2: 240.81,
    xlinkHref: "#radial-gradient-53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 96.08,
    y1: 241.61,
    x2: 52.18,
    y2: 256.41,
    xlinkHref: "#radial-gradient-53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 369.42,
    y1: 245.8,
    x2: 326.69,
    y2: 260.2,
    xlinkHref: "#radial-gradient-53"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.11,62.58c-44.71,0-81,21.1-81,47.14,0,.22,0,.44,0,.65h0v48.45c0-26,36.25-47.15,81-47.15Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.65,158.82h-1v-49.1c0-26.27,36.54-47.64,81.46-47.64h.5v50.09h-.5C312.75,112.17,276.65,133.1,276.65,158.82Zm0-47.95v40.48c6.12-22.64,39.61-40,80-40.18V63.08c-44.13.15-80,21-80,46.64,0,.12,0,.23,0,.34s0,.2,0,.3v.51Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.8,128c1.06-.77,2.17-1.53,3.32-2.28V111.46c-1.16.85-2.27,1.72-3.32,2.61Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.42,93.68c-1.13.42-2.24.85-3.33,1.3v22.49c1.1-.44,2.2-.86,3.33-1.27Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308,88.62c-1.14.52-2.25,1-3.33,1.61v30.08c1.09-.53,2.2-1,3.33-1.54Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M282.26,109.84a28.93,28.93,0,0,0-3.32,8.86v22.54a38.41,38.41,0,0,1,3.32-4.57Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M301.55,121.9V103.46c-1.14.66-2.25,1.33-3.32,2v18.28l.47-.28C299.63,122.94,300.59,122.41,301.55,121.9Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.69,130.37V97.66a42.45,42.45,0,0,0-3.32,3.73v32C286.41,132.32,287.52,131.34,288.69,130.37Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.71,84.65c-1.12.2-2.23.41-3.32.64v26.42c1.1-.23,2.2-.45,3.32-.65Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M353,82.68q-1.68.06-3.33.15v26.36c1.11-.06,2.21-.12,3.33-.15Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M346.57,75.32c-1.11.08-2.22.18-3.32.29v34.1c1.1-.12,2.21-.22,3.32-.31Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M327.28,97.54c-1.12.27-2.23.54-3.33.84v14.85c1.1-.29,2.21-.57,3.33-.83Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M320.85,80c-1.13.34-2.23.69-3.33,1v34.12c1.1-.36,2.21-.71,3.33-1Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M340.14,72.11c-1.11.14-2.22.3-3.32.46v38c1.1-.17,2.21-.32,3.32-.47Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.47 227.12 259.07 225.73 261.46 224.35 263.87 225.74 261.47 227.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "265.16 229.25 262.75 227.86 265.15 226.48 267.55 227.87 265.16 229.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "268.85 231.38 266.44 229.99 268.83 228.61 271.24 230 268.85 231.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "272.53 233.51 270.13 232.12 272.52 230.74 274.93 232.13 272.53 233.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "276.22 235.64 273.81 234.25 276.2 232.87 278.61 234.26 276.22 235.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "279.91 237.77 277.5 236.38 279.89 235 282.3 236.38 279.91 237.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "283.59 239.89 281.19 238.5 283.58 237.12 285.99 238.51 283.59 239.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "257.83 229.23 255.43 227.84 257.82 226.46 260.23 227.84 257.83 229.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.52 231.35 259.11 229.97 261.5 228.58 263.91 229.97 261.52 231.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "265.21 233.48 262.8 232.09 265.19 230.71 267.6 232.1 265.21 233.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "268.89 235.61 266.49 234.22 268.88 232.84 271.29 234.23 268.89 235.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "272.58 237.74 270.17 236.35 272.56 234.97 274.97 236.36 272.58 237.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "276.27 239.87 273.86 238.48 276.25 237.1 278.66 238.49 276.27 239.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "279.95 242 277.55 240.61 279.94 239.23 282.34 240.62 279.95 242"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "254.19 231.33 251.78 229.94 254.18 228.56 256.58 229.95 254.19 231.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "257.88 233.46 255.47 232.07 257.86 230.69 260.27 232.07 257.88 233.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.56 235.59 259.16 234.19 261.55 232.81 263.96 234.2 261.56 235.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "265.25 237.71 262.85 236.32 265.24 234.94 267.64 236.33 265.25 237.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "268.94 239.84 266.53 238.45 268.92 237.07 271.33 238.46 268.94 239.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "272.63 241.97 270.22 240.58 272.61 239.2 275.02 240.59 272.63 241.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "276.31 244.1 273.9 242.71 276.3 241.33 278.7 242.72 276.31 244.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "250.55 233.43 248.14 232.04 250.54 230.66 252.94 232.05 250.55 233.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "254.24 235.56 251.83 234.17 254.22 232.79 256.63 234.18 254.24 235.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "257.92 237.69 255.52 236.3 257.91 234.92 260.32 236.31 257.92 237.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.61 239.81 259.2 238.43 261.6 237.04 264 238.43 261.61 239.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "265.3 241.94 262.89 240.55 265.28 239.17 267.69 240.56 265.3 241.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "268.98 244.07 266.58 242.68 268.97 241.3 271.38 242.69 268.98 244.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "272.67 246.2 270.26 244.81 272.65 243.43 275.06 244.82 272.67 246.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "246.91 235.53 244.5 234.14 246.9 232.76 249.3 234.15 246.91 235.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "250.6 237.66 248.19 236.27 250.58 234.89 252.99 236.28 250.6 237.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "254.28 239.79 251.88 238.4 254.27 237.02 256.68 238.41 254.28 239.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "257.97 241.92 255.56 240.53 257.95 239.15 260.36 240.54 257.97 241.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.66 244.05 259.25 242.66 261.64 241.28 264.05 242.66 261.66 244.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "265.34 246.17 262.94 244.78 265.33 243.4 267.74 244.79 265.34 246.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "269.03 248.3 266.62 246.91 269.01 245.53 271.42 246.92 269.03 248.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.27 237.63 240.86 236.25 243.25 234.86 245.66 236.25 243.27 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "246.96 239.76 244.55 238.37 246.94 236.99 249.35 238.38 246.96 239.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "250.64 241.89 248.24 240.5 250.63 239.12 253.03 240.51 250.64 241.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "254.33 244.02 251.92 242.63 254.31 241.25 256.72 242.64 254.33 244.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "258.01 246.15 255.61 244.76 258 243.38 260.41 244.77 258.01 246.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.7 248.28 259.3 246.89 261.69 245.51 264.09 246.9 261.7 248.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "265.39 250.41 262.98 249.01 265.37 247.63 267.78 249.02 265.39 250.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "239.63 239.74 237.22 238.35 239.61 236.97 242.02 238.36 239.63 239.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.31 241.87 240.91 240.47 243.3 239.09 245.71 240.48 243.31 241.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "247 243.99 244.59 242.6 246.99 241.22 249.39 242.61 247 243.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "250.69 246.12 248.28 244.73 250.67 243.35 253.08 244.74 250.69 246.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "254.37 248.25 251.97 246.86 254.36 245.48 256.77 246.87 254.37 248.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "258.06 250.38 255.65 248.99 258.05 247.61 260.45 249 258.06 250.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.75 252.51 259.34 251.12 261.73 249.74 264.14 251.13 261.75 252.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "235.99 241.84 233.58 240.45 235.97 239.07 238.38 240.46 235.99 241.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "239.67 243.97 237.27 242.58 239.66 241.2 242.06 242.59 239.67 243.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.36 246.1 240.95 244.71 243.34 243.32 245.75 244.72 243.36 246.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "247.05 248.22 244.64 246.83 247.03 245.45 249.44 246.84 247.05 248.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "250.73 250.35 248.33 248.96 250.72 247.58 253.13 248.97 250.73 250.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "254.42 252.48 252.01 251.09 254.41 249.71 256.81 251.1 254.42 252.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "258.11 254.61 255.7 253.22 258.09 251.84 260.5 253.23 258.11 254.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "232.35 243.94 229.94 242.55 232.33 241.17 234.74 242.56 232.35 243.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "236.03 246.07 233.63 244.68 236.02 243.3 238.42 244.69 236.03 246.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "239.72 248.2 237.31 246.81 239.7 245.43 242.11 246.82 239.72 248.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.41 250.33 241 248.94 243.39 247.56 245.8 248.94 243.41 250.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "247.09 252.45 244.69 251.06 247.08 249.68 249.48 251.07 247.09 252.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "250.78 254.58 248.37 253.19 250.76 251.81 253.17 253.2 250.78 254.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "254.47 256.71 252.06 255.32 254.45 253.94 256.86 255.33 254.47 256.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "228.71 246.04 226.3 244.65 228.69 243.27 231.1 244.66 228.71 246.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "232.39 248.17 229.98 246.78 232.38 245.4 234.78 246.79 232.39 248.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "236.08 250.3 233.67 248.91 236.06 247.53 238.47 248.92 236.08 250.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "239.76 252.43 237.36 251.04 239.75 249.66 242.16 251.05 239.76 252.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.45 254.56 241.04 253.17 243.44 251.79 245.84 253.18 243.45 254.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "247.14 256.69 244.73 255.29 247.12 253.91 249.53 255.3 247.14 256.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "250.82 258.81 248.42 257.42 250.81 256.04 253.22 257.43 250.82 258.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "225.06 248.15 222.66 246.76 225.05 245.37 227.46 246.76 225.06 248.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "228.75 250.27 226.34 248.88 228.74 247.5 231.14 248.89 228.75 250.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "232.44 252.4 230.03 251.01 232.42 249.63 234.83 251.02 232.44 252.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "236.12 254.53 233.72 253.14 236.11 251.76 238.51 253.15 236.12 254.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "239.81 256.66 237.4 255.27 239.79 253.89 242.2 255.28 239.81 256.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.5 258.79 241.09 257.4 243.48 256.02 245.89 257.41 243.5 258.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "247.18 260.92 244.78 259.53 247.17 258.14 249.57 259.54 247.18 260.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.42 250.25 219.02 248.86 221.41 247.48 223.81 248.87 221.42 250.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "225.11 252.38 222.7 250.99 225.09 249.6 227.5 251 225.11 252.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "228.8 254.5 226.39 253.11 228.78 251.73 231.19 253.12 228.8 254.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "232.48 256.63 230.07 255.24 232.47 253.86 234.87 255.25 232.48 256.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "236.17 258.76 233.76 257.37 236.15 255.99 238.56 257.38 236.17 258.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "239.85 260.89 237.45 259.5 239.84 258.12 242.25 259.51 239.85 260.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "243.54 263.02 241.13 261.63 243.53 260.25 245.93 261.64 243.54 263.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "217.78 252.35 215.38 250.96 217.77 249.58 220.17 250.97 217.78 252.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.47 254.48 219.06 253.09 221.45 251.71 223.86 253.1 221.47 254.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "225.16 256.61 222.75 255.22 225.14 253.84 227.55 255.22 225.16 256.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "228.84 258.74 226.43 257.35 228.83 255.96 231.23 257.35 228.84 258.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "232.53 260.86 230.12 259.47 232.51 258.09 234.92 259.48 232.53 260.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "236.21 262.99 233.81 261.6 236.2 260.22 238.61 261.61 236.21 262.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "239.9 265.12 237.49 263.73 239.89 262.35 242.29 263.74 239.9 265.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "214.14 254.45 211.73 253.06 214.13 251.68 216.53 253.07 214.14 254.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "217.83 256.58 215.42 255.19 217.81 253.81 220.22 255.2 217.83 256.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.51 258.71 219.11 257.32 221.5 255.94 223.91 257.33 221.51 258.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "225.2 260.84 222.79 259.45 225.19 258.07 227.59 259.46 225.2 260.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "228.89 262.96 226.48 261.58 228.87 260.19 231.28 261.58 228.89 262.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "232.57 265.09 230.17 263.7 232.56 262.32 234.97 263.71 232.57 265.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "236.26 267.22 233.85 265.83 236.25 264.45 238.65 265.84 236.26 267.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "210.5 256.55 208.09 255.16 210.49 253.78 212.89 255.17 210.5 256.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "214.19 258.68 211.78 257.29 214.17 255.91 216.58 257.3 214.19 258.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "217.87 260.81 215.47 259.42 217.86 258.04 220.26 259.43 217.87 260.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.56 262.94 219.15 261.55 221.54 260.17 223.95 261.56 221.56 262.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "225.25 265.07 222.84 263.68 225.23 262.3 227.64 263.69 225.25 265.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "228.93 267.2 226.53 265.81 228.92 264.43 231.32 265.81 228.93 267.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "232.62 269.32 230.21 267.94 232.6 266.55 235.01 267.94 232.62 269.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "206.86 258.66 204.45 257.27 206.84 255.88 209.25 257.27 206.86 258.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "210.54 260.78 208.14 259.39 210.53 258.01 212.94 259.4 210.54 260.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "214.23 262.91 211.82 261.52 214.22 260.14 216.62 261.53 214.23 262.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "217.92 265.04 215.51 263.65 217.9 262.27 220.31 263.66 217.92 265.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.6 267.17 219.2 265.78 221.59 264.4 224 265.79 221.6 267.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "225.29 269.3 222.88 267.91 225.28 266.53 227.68 267.92 225.29 269.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "228.98 271.43 226.57 270.04 228.96 268.66 231.37 270.05 228.98 271.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.22 260.76 200.81 259.37 203.2 257.99 205.61 259.38 203.22 260.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "206.9 262.89 204.5 261.5 206.89 260.12 209.3 261.51 206.9 262.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "210.59 265.01 208.18 263.63 210.58 262.24 212.98 263.63 210.59 265.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "214.28 267.14 211.87 265.75 214.26 264.37 216.67 265.76 214.28 267.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "217.96 269.27 215.56 267.88 217.95 266.5 220.36 267.89 217.96 269.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.65 271.4 219.24 270.01 221.63 268.63 224.04 270.02 221.65 271.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "225.34 273.53 222.93 272.14 225.32 270.76 227.73 272.15 225.34 273.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "199.58 262.86 197.17 261.47 199.56 260.09 201.97 261.48 199.58 262.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.26 264.99 200.86 263.6 203.25 262.22 205.66 263.61 203.26 264.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "206.95 267.12 204.54 265.73 206.94 264.35 209.34 265.74 206.95 267.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "210.64 269.25 208.23 267.86 210.62 266.48 213.03 267.86 210.64 269.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "214.32 271.37 211.92 269.98 214.31 268.6 216.72 269.99 214.32 271.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "218.01 273.5 215.6 272.11 217.99 270.73 220.4 272.12 218.01 273.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.7 275.63 219.29 274.24 221.68 272.86 224.09 274.25 221.7 275.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "195.94 264.96 193.53 263.57 195.92 262.19 198.33 263.58 195.94 264.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "199.62 267.09 197.22 265.7 199.61 264.32 202.01 265.71 199.62 267.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.31 269.22 200.9 267.83 203.29 266.45 205.7 267.84 203.31 269.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "207 271.35 204.59 269.96 206.98 268.58 209.39 269.97 207 271.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "210.68 273.48 208.28 272.09 210.67 270.7 213.07 272.1 210.68 273.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "214.37 275.61 211.96 274.21 214.35 272.83 216.76 274.22 214.37 275.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "218.06 277.73 215.65 276.34 218.04 274.96 220.45 276.35 218.06 277.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "192.29 267.06 189.89 265.68 192.28 264.29 194.69 265.68 192.29 267.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "195.98 269.19 193.57 267.8 195.97 266.42 198.37 267.81 195.98 269.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "199.67 271.32 197.26 269.93 199.65 268.55 202.06 269.94 199.67 271.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.35 273.45 200.95 272.06 203.34 270.68 205.75 272.07 203.35 273.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "207.04 275.58 204.63 274.19 207.03 272.81 209.43 274.2 207.04 275.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "210.73 277.71 208.32 276.32 210.71 274.94 213.12 276.33 210.73 277.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "214.41 279.83 212.01 278.44 214.4 277.06 216.81 278.45 214.41 279.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "188.65 269.17 186.25 267.78 188.64 266.4 191.04 267.79 188.65 269.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "192.34 271.3 189.93 269.9 192.32 268.52 194.73 269.91 192.34 271.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "196.03 273.42 193.62 272.03 196.01 270.65 198.42 272.04 196.03 273.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "199.71 275.55 197.31 274.16 199.7 272.78 202.1 274.17 199.71 275.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.4 277.68 200.99 276.29 203.38 274.91 205.79 276.3 203.4 277.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "207.09 279.81 204.68 278.42 207.07 277.04 209.48 278.43 207.09 279.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "210.77 281.94 208.37 280.55 210.76 279.17 213.16 280.56 210.77 281.94"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "327.97 265.37 325.57 263.98 327.96 262.6 330.37 263.99 327.97 265.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "331.66 267.5 329.25 266.11 331.65 264.73 334.05 266.12 331.66 267.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "335.35 269.63 332.94 268.24 335.33 266.86 337.74 268.25 335.35 269.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "339.03 271.76 336.63 270.37 339.02 268.99 341.43 270.38 339.03 271.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "342.72 273.89 340.31 272.5 342.7 271.12 345.11 272.51 342.72 273.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "346.41 276.02 344 274.63 346.39 273.25 348.8 274.63 346.41 276.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "350.09 278.14 347.69 276.75 350.08 275.37 352.49 276.76 350.09 278.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "324.33 267.48 321.93 266.09 324.32 264.7 326.73 266.1 324.33 267.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "328.02 269.6 325.61 268.21 328 266.83 330.41 268.22 328.02 269.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "331.71 271.73 329.3 270.34 331.69 268.96 334.1 270.35 331.71 271.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "335.39 273.86 332.99 272.47 335.38 271.09 337.79 272.48 335.39 273.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "339.08 275.99 336.67 274.6 339.06 273.22 341.47 274.61 339.08 275.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "342.77 278.12 340.36 276.73 342.75 275.35 345.16 276.74 342.77 278.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "346.45 280.25 344.05 278.86 346.44 277.48 348.84 278.87 346.45 280.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "320.69 269.58 318.29 268.19 320.68 266.81 323.08 268.2 320.69 269.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "324.38 271.71 321.97 270.32 324.36 268.94 326.77 270.32 324.38 271.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "328.06 273.83 325.66 272.44 328.05 271.06 330.46 272.45 328.06 273.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "331.75 275.96 329.35 274.57 331.74 273.19 334.14 274.58 331.75 275.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "335.44 278.09 333.03 276.7 335.42 275.32 337.83 276.71 335.44 278.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "339.13 280.22 336.72 278.83 339.11 277.45 341.52 278.84 339.13 280.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "342.81 282.35 340.4 280.96 342.8 279.58 345.2 280.97 342.81 282.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "317.05 271.68 314.64 270.29 317.04 268.91 319.44 270.3 317.05 271.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "320.74 273.81 318.33 272.42 320.72 271.04 323.13 272.43 320.74 273.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "324.42 275.94 322.02 274.55 324.41 273.17 326.82 274.56 324.42 275.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "328.11 278.06 325.7 276.68 328.1 275.3 330.5 276.68 328.11 278.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "331.8 280.19 329.39 278.8 331.78 277.42 334.19 278.81 331.8 280.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "335.48 282.32 333.08 280.93 335.47 279.55 337.88 280.94 335.48 282.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "339.17 284.45 336.76 283.06 339.15 281.68 341.56 283.07 339.17 284.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "313.41 273.78 311 272.39 313.39 271.01 315.8 272.4 313.41 273.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "317.1 275.91 314.69 274.52 317.08 273.14 319.49 274.53 317.1 275.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "320.78 278.04 318.38 276.65 320.77 275.27 323.18 276.66 320.78 278.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "324.47 280.17 322.06 278.78 324.45 277.4 326.86 278.79 324.47 280.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "328.16 282.3 325.75 280.91 328.14 279.52 330.55 280.92 328.16 282.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "331.84 284.42 329.44 283.04 331.83 281.65 334.24 283.04 331.84 284.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "335.53 286.55 333.12 285.16 335.51 283.78 337.92 285.17 335.53 286.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "309.77 275.88 307.36 274.5 309.75 273.11 312.16 274.5 309.77 275.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "313.46 278.01 311.05 276.62 313.44 275.24 315.85 276.63 313.46 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "317.14 280.14 314.74 278.75 317.13 277.37 319.53 278.76 317.14 280.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "320.83 282.27 318.42 280.88 320.81 279.5 323.22 280.89 320.83 282.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "324.51 284.4 322.11 283.01 324.5 281.63 326.91 283.02 324.51 284.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "328.2 286.53 325.8 285.14 328.19 283.76 330.59 285.14 328.2 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "331.89 288.65 329.48 287.26 331.87 285.88 334.28 287.27 331.89 288.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "306.13 277.99 303.72 276.6 306.11 275.22 308.52 276.61 306.13 277.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "309.81 280.12 307.41 278.73 309.8 277.34 312.21 278.73 309.81 280.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "313.5 282.24 311.09 280.85 313.49 279.47 315.89 280.86 313.5 282.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "317.19 284.37 314.78 282.98 317.17 281.6 319.58 282.99 317.19 284.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "320.87 286.5 318.47 285.11 320.86 283.73 323.27 285.12 320.87 286.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "324.56 288.63 322.15 287.24 324.55 285.86 326.95 287.25 324.56 288.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "328.25 290.76 325.84 289.37 328.23 287.99 330.64 289.38 328.25 290.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "302.49 280.09 300.08 278.7 302.47 277.32 304.88 278.71 302.49 280.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "306.17 282.22 303.77 280.83 306.16 279.45 308.56 280.84 306.17 282.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "309.86 284.35 307.45 282.96 309.85 281.57 312.25 282.96 309.86 284.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "313.55 286.47 311.14 285.08 313.53 283.7 315.94 285.09 313.55 286.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "317.23 288.6 314.83 287.21 317.22 285.83 319.63 287.22 317.23 288.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "320.92 290.73 318.51 289.34 320.9 287.96 323.31 289.35 320.92 290.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "324.61 292.86 322.2 291.47 324.59 290.09 327 291.48 324.61 292.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "298.85 282.19 296.44 280.8 298.83 279.42 301.24 280.81 298.85 282.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "302.53 284.32 300.13 282.93 302.52 281.55 304.92 282.94 302.53 284.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "306.22 286.45 303.81 285.06 306.2 283.68 308.61 285.07 306.22 286.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "309.91 288.58 307.5 287.19 309.89 285.81 312.3 287.19 309.91 288.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "313.59 290.7 311.19 289.31 313.58 287.93 315.98 289.32 313.59 290.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "317.28 292.83 314.87 291.44 317.26 290.06 319.67 291.45 317.28 292.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "320.96 294.96 318.56 293.57 320.95 292.19 323.36 293.58 320.96 294.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.2 284.29 292.8 282.9 295.19 281.52 297.6 282.91 295.2 284.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "298.89 286.42 296.48 285.03 298.88 283.65 301.28 285.04 298.89 286.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "302.58 288.55 300.17 287.16 302.56 285.78 304.97 287.17 302.58 288.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "306.26 290.68 303.86 289.29 306.25 287.91 308.66 289.3 306.26 290.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "309.95 292.81 307.54 291.42 309.94 290.04 312.34 291.43 309.95 292.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "313.64 294.94 311.23 293.55 313.62 292.16 316.03 293.55 313.64 294.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "317.32 297.06 314.92 295.67 317.31 294.29 319.72 295.68 317.32 297.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "291.56 286.39 289.16 285.01 291.55 283.62 293.96 285.01 291.56 286.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.25 288.52 292.84 287.13 295.24 285.75 297.64 287.14 295.25 288.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "298.94 290.65 296.53 289.26 298.92 287.88 301.33 289.27 298.94 290.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "302.62 292.78 300.22 291.39 302.61 290.01 305.01 291.4 302.62 292.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "306.31 294.91 303.9 293.52 306.3 292.14 308.7 293.53 306.31 294.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "310 297.04 307.59 295.65 309.98 294.27 312.39 295.66 310 297.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "313.68 299.17 311.28 297.78 313.67 296.39 316.07 297.79 313.68 299.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "287.92 288.5 285.52 287.11 287.91 285.73 290.31 287.12 287.92 288.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "291.61 290.63 289.2 289.24 291.59 287.86 294 289.25 291.61 290.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.3 292.75 292.89 291.36 295.28 289.98 297.69 291.37 295.3 292.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "298.98 294.88 296.57 293.49 298.97 292.11 301.37 293.5 298.98 294.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "302.67 297.01 300.26 295.62 302.65 294.24 305.06 295.63 302.67 297.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "306.36 299.14 303.95 297.75 306.34 296.37 308.75 297.76 306.36 299.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "310.04 301.27 307.63 299.88 310.03 298.5 312.43 299.89 310.04 301.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "284.28 290.6 281.88 289.21 284.27 287.83 286.67 289.22 284.28 290.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "287.97 292.73 285.56 291.34 287.95 289.96 290.36 291.35 287.97 292.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "291.65 294.86 289.25 293.47 291.64 292.09 294.05 293.48 291.65 294.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.34 296.99 292.93 295.6 295.33 294.21 297.73 295.6 295.34 296.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "299.03 299.11 296.62 297.72 299.01 296.34 301.42 297.73 299.03 299.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "302.71 301.24 300.31 299.85 302.7 298.47 305.11 299.86 302.71 301.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "306.4 303.37 303.99 301.98 306.39 300.6 308.79 301.99 306.4 303.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "280.64 292.7 278.23 291.31 280.63 289.93 283.03 291.32 280.64 292.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "284.33 294.83 281.92 293.44 284.31 292.06 286.72 293.45 284.33 294.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "288.01 296.96 285.61 295.57 288 294.19 290.41 295.58 288.01 296.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "291.7 299.09 289.29 297.7 291.69 296.32 294.09 297.71 291.7 299.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.39 301.21 292.98 299.83 295.37 298.44 297.78 299.83 295.39 301.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "299.07 303.34 296.67 301.95 299.06 300.57 301.46 301.96 299.07 303.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "302.76 305.47 300.35 304.08 302.75 302.7 305.15 304.09 302.76 305.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "277 294.8 274.59 293.41 276.99 292.03 279.39 293.42 277 294.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "280.69 296.93 278.28 295.54 280.67 294.16 283.08 295.55 280.69 296.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "284.37 299.06 281.97 297.67 284.36 296.29 286.76 297.68 284.37 299.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "288.06 301.19 285.65 299.8 288.04 298.42 290.45 299.81 288.06 301.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "291.75 303.32 289.34 301.93 291.73 300.55 294.14 301.94 291.75 303.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.43 305.45 293.02 304.06 295.42 302.68 297.82 304.06 295.43 305.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "299.12 307.57 296.71 306.19 299.1 304.8 301.51 306.19 299.12 307.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "273.36 296.91 270.95 295.52 273.34 294.13 275.75 295.52 273.36 296.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "277.05 299.03 274.64 297.64 277.03 296.26 279.44 297.65 277.05 299.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "280.73 301.16 278.32 299.77 280.72 298.39 283.12 299.78 280.73 301.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "284.42 303.29 282.01 301.9 284.4 300.52 286.81 301.91 284.42 303.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "288.11 305.42 285.7 304.03 288.09 302.65 290.5 304.04 288.11 305.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "291.79 307.55 289.38 306.16 291.78 304.78 294.18 306.17 291.79 307.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.48 309.68 293.07 308.29 295.46 306.91 297.87 308.3 295.48 309.68"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M325.1,227.41c10.38,4.33,15.51.88,23.31-3.62s8.69-8.95,2.69-11.76c-11.31-5.3-17.76.05-25.56,4.56S319,224.85,325.1,227.41Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M360.75,157.84c.85.2,1.23.47,1.15,1.31s0,3.9.07,5.21a15.28,15.28,0,0,1-1.07,4.28,4.44,4.44,0,0,1-.59,1.81c-.47.63-.81.42-1,.28a1.37,1.37,0,0,1,0-1,14.29,14.29,0,0,0,.16-1.89s-.55,2.11-.74,2.9-.72,1.57-1.22,1.6a.6.6,0,0,1-.66-.65,8.73,8.73,0,0,0,.49-1.66c0-.53,0-1.39,0-1.39a11.87,11.87,0,0,1-.68,2.87c-.22.5-.72,2.35-1.62,1.89-.68-.34.16-2,.28-2.47a17,17,0,0,0,.28-5.45c-.18-1.14-.59-1.6-1.65-.62s-2.06,1.6-2.3,1,.76-1.79,1.41-2.56a13.56,13.56,0,0,1,2.54-2.19c1.57-1,1.6-2.76,2.62-3.29A3.26,3.26,0,0,1,360.75,157.84Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M360.75,157.84c.85.2,1.23.47,1.15,1.31s0,3.9.07,5.21a15.28,15.28,0,0,1-1.07,4.28,4.44,4.44,0,0,1-.59,1.81c-.47.63-.81.42-1,.28a1.37,1.37,0,0,1,0-1,14.29,14.29,0,0,0,.16-1.89s-.55,2.11-.74,2.9-.72,1.57-1.22,1.6a.6.6,0,0,1-.66-.65,8.73,8.73,0,0,0,.49-1.66c0-.53,0-1.39,0-1.39a11.87,11.87,0,0,1-.68,2.87c-.22.5-.72,2.35-1.62,1.89-.68-.34.16-2,.28-2.47a17,17,0,0,0,.28-5.45c-.18-1.14-.59-1.6-1.65-.62s-2.06,1.6-2.3,1,.76-1.79,1.41-2.56a13.56,13.56,0,0,1,2.54-2.19c1.57-1,1.6-2.76,2.62-3.29A3.26,3.26,0,0,1,360.75,157.84Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M357.62,121.74a2.48,2.48,0,1,1-2.48-2.48A2.48,2.48,0,0,1,357.62,121.74Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.35,157.42a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,362.35,157.42Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M362.44,137c.92.4,1.25,2.12,1,7.41-.21,5.11-.34,12.29-.94,12.94s-3.82.12-4.28-.62-.33-4.53-.46-8.43c-.14-4.42-.72-7.11-.07-8.46S361,136.33,362.44,137Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M360.55,137.62c.52.38.7,2,.59,6.95-.12,4.8-.19,11.54-.54,12.15s-2.16.11-2.42-.59-.19-4.25-.26-7.9c-.08-4.15-.41-6.67,0-7.94S359.71,137,360.55,137.62Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M362.27,137.11a2.48,2.48,0,1,1-2.48-2.48A2.48,2.48,0,0,1,362.27,137.11Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M358,120.8c.89-.16,1.43,2,1.88,4.46s1.74,9.11,1.78,9.76c.06.87-3.19,2.72-4.21,2.85s-2.24-5.56-2.74-7.59c-.6-2.48-.9-4.42-.45-5.25S357,121,358,120.8Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M355.53,122.4c.37-.15.9,1.82,1.44,4.1s2,8.41,2.11,9a3.78,3.78,0,0,1-1.46,2.64c-.42.13-1.75-5.12-2.24-7a19.29,19.29,0,0,1-.92-4.84C354.54,125.53,355.13,122.56,355.53,122.4Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M339.43,220.63c1.13,1,1.63,4.67.18,6s-2.93.1-6.15,0-9.38-1.4-9.56-3.59,2.52-2.38,4.66-2.56,4.15-1.22,5.41-1.31S338.08,219.42,339.43,220.63Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M339.43,220.63c1.13,1,1.63,4.67.18,6s-2.93.1-6.15,0-9.38-1.4-9.56-3.59,2.52-2.38,4.66-2.56,4.15-1.22,5.41-1.31S338.08,219.42,339.43,220.63Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M339.79,219.81a2.48,2.48,0,1,1-2.48-2.48A2.49,2.49,0,0,1,339.79,219.81Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.5,214.59c.94.9,2,6.25.1,7.09s-3.87-.56-4.53-1.54a8.23,8.23,0,0,0-2.94-2.56c-1.21-.66-2.79-3.27-1.49-4.43s3.64.23,4.53.23S348.24,213.38,349.5,214.59Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M349.5,214.59c.94.9.65,4-1.22,4.85s-4.93-1.21-6.15-1.86-2.79-3.27-1.49-4.43,3.64.23,4.53.23S348.24,213.38,349.5,214.59Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M349.56,213.61a2.48,2.48,0,1,1-2.48-2.48A2.48,2.48,0,0,1,349.56,213.61Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M347.5,185.11c2.66,2.66,3.09,27,1.83,28s-4.26.8-4.68-.53-.83-6.09-1.88-13.26c-1.11-7.58-2.3-10.44-1.74-12.6A4,4,0,0,1,347.5,185.11Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M346.57,186.48c2.17,2.1,2.62,23.67,1.66,24.51s-3.25.69-3.57-.45-.45-5.55-1.11-11.71c-.74-6.92-1.61-10.18-1.48-11C342.41,185.74,344.08,184.08,346.57,186.48Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M346.78,184.5a3.16,3.16,0,1,1-3.16-3.16A3.17,3.17,0,0,1,346.78,184.5Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M347,183.1c-.59,3.56-6.54,3.2-7.37.76s-.24-21.32-.28-26.66c0-4.92.19-13.13,5.69-12.57s7.65,4.71,7.23,9.1-3.73,14.22-4.43,19.73S347.24,181.74,347,183.1Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M296.51,110.62a4.2,4.2,0,0,0,0-2.09c-.13-1,.63-2.17.63-3.85s-.42-3-.45-3.88-.31-1.3-1-.84-.39,3.18-.84,3.56-2.21-1.5-3.5-3.6S289.55,96,288.89,96s-.77.81-.28,1.93l1.29,2.94a18.25,18.25,0,0,1-1.43-2.31c-.3-.68-.25-1-.63-1.12s-.77,1-.35,2.34a13.63,13.63,0,0,0,1.05,2.38,7.35,7.35,0,0,1-.87-1.33c-.25-.56-.21-.63-.53-.63s-.43,1.36,0,2.1.67,1.19.67,1.19-.53-1.08-.8-1,.42,1.88.63,2.37a19,19,0,0,0,2.76,3.89c1.22,1.25,2.2,3.67,2.94,4S296.27,111.6,296.51,110.62Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M296.51,110.62a4.2,4.2,0,0,0,0-2.09c-.13-1,.63-2.17.63-3.85s-.42-3-.45-3.88-.31-1.3-1-.84-.39,3.18-.84,3.56-2.21-1.5-3.5-3.6S289.55,96,288.89,96s-.77.81-.28,1.93l1.29,2.94a18.25,18.25,0,0,1-1.43-2.31c-.3-.68-.25-1-.63-1.12s-.77,1-.35,2.34a13.63,13.63,0,0,0,1.05,2.38,7.35,7.35,0,0,1-.87-1.33c-.25-.56-.21-.63-.53-.63s-.43,1.36,0,2.1.67,1.19.67,1.19-.53-1.08-.8-1,.42,1.88.63,2.37a19,19,0,0,0,2.76,3.89c1.22,1.25,2.2,3.67,2.94,4S296.27,111.6,296.51,110.62Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M297.62,112.42a2.06,2.06,0,1,1-2.06-2.06A2.07,2.07,0,0,1,297.62,112.42Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M297.2,111.17c-.79-.2-2.72,1.49-2.87,2.58-.27,1.84,14,19.58,18.08,19.83,3.12.19,4.92-3.18,2.1-6C312.89,126,299,111.62,297.2,111.17Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M299.65,113.76c-.54-.16-1.81,1.36-2,2-.25,1.12,9,12.63,11.9,13,2.18.26,3.43-2.3,1.56-4.13C310.07,123.57,300.91,114.12,299.65,113.76Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M350.93,133.77c-.38,2.1-3.29,17.8-6.21,21.54-1.76,2.27-7.91,2.44-10,1.06-2.67-1.81-2.82-14.86-2.82-14.86Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M347.64,114.13c2.93-.22,9.16.07,9.58,3.43s-2.23,6.26-2.86,7.94-1,7.23-1.67,9.19-1.54,5.1-7.42,6.92-12.18,2-13.58.51-5.11-11.9-4.34-16.44,6.37-8.33,10.63-9.66A35.05,35.05,0,0,1,347.64,114.13Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M347.64,114.13c2.93-.22,9.16.07,9.58,3.43s-2.23,6.26-2.86,7.94-1,7.23-1.67,9.19-1.54,5.1-7.42,6.92-12.18,2-13.58.51-5.11-11.9-4.34-16.44,6.37-8.33,10.63-9.66A35.05,35.05,0,0,1,347.64,114.13Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M347.64,114.13c2.93-.22,9.16.07,9.58,3.43s-4.76,6.39-6.45,7c-8.91,3.2-24.19,5.66-23.42,1.12s6.37-8.33,10.63-9.66A35.05,35.05,0,0,1,347.64,114.13Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M327.25,127.16c.27-1.12.78,2.83,3.72,3.68,3.15.91,5.11.87,5.39,2.87.19,1.41.55,6.24-1.07,9.1-1.73.11-3-.08-3.6-.69C330.42,140.79,327.28,132.17,327.25,127.16Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M332.25,131.27c-1.75-.11-4.06-2.45-4.06-2.66s-.28.42-1.75,1-2.66,3.64-1,4.62,4.41,2.31,6.3,1.33S334.42,131.41,332.25,131.27Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M339.41,219.49c-1,.79-4.37.15-4.65-.69s-1.75-7.94-3.13-13.64c-1.6-6.61-3-10.4-2.78-12,.23-1.77,3.51-2.8,5.19-2.48s2.27,1.4,2.67,3.66,1.91,10.73,2.3,15.38C339.36,213.94,340.25,218.84,339.41,219.49Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M338.68,219.16c-.7.85-3.23.4-3.5-.42s-1.9-7.82-3.36-13.43c-1.69-6.51-3-10.2-3-11.78,0-1.78,2.4-3,3.67-2.76s1.79,1.26,2.27,3.5,2.22,10.59,2.86,15.21C338.23,213.63,339.25,218.46,338.68,219.16Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M334.42,190.78a3.16,3.16,0,1,1-3.15-3.16A3.16,3.16,0,0,1,334.42,190.78Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M317.57,131.22a2.48,2.48,0,1,1-2.48-2.48A2.49,2.49,0,0,1,317.57,131.22Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M316,128.63c-1.42.14-1.63,2.33-1.39,3.72s.87,2.09,3.27,2.72c2.09.55,11,2.19,12.67,1.88s.49-4-1.11-5.71-1.84-1.94-4-1.93S318.19,128.41,316,128.63Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M316,128.89c-1.42.12-1.63,2-1.39,3.24.22,1.07.87,1.81,3.27,2.35,2.09.48,11,1.91,12.67,1.64s.19-3.72-1.46-5-1.49-1.68-3.64-1.67S318.19,128.7,316,128.89Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M344.09,97.75c2.31,1.47,3.15,4.76,2,7.7s-2.73,3.64-2,6.44,1.57,2.89,1.27,3.71-1.19,1.26-3.29,1.61-4,.23-4.47-.28-.05-2.5-.78-3.85c-.41-.77-1-1.83-1-1.83S338.15,94,344.09,97.75Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M337.65,111.82a5.89,5.89,0,0,1-4.19.14c-.86-.52-2.94-8.75-1.4-12.32s8.47-6,12.54-2.49c3.26,2.78,2.29,5.95,1.93,6-.9.13-5.85,1.45-6.48,2.71S339.26,110.7,337.65,111.82Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M334.69,189.78a4.81,4.81,0,0,1-5.45,2.1c-1.78-.36-2.57-2-2.57-3.92s.09-18,.51-23.38c.3-3.88.35-12.32,4.52-14.06a7.56,7.56,0,0,1,10.72,8.14c-1,4.39-4.87,10.12-5.85,16.57S335.65,188.16,334.69,189.78Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M331.33,188.22c-.7,1.86-1.9,2.29-3.07,1.88-1-.35-1.41-1.82-1.39-3.61s.47-16.06.78-21c.21-3.55,0-12.5,2.52-13.23,4.05-1.17,6.15,3.42,5.88,7.55-.22,3.32-2.85,9.22-3.48,15.12S331.89,186.74,331.33,188.22Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M335.67,111.82c1.15-.73,2.71-3.65,3.44-8,.5-3,4.81-3.75,7.48-3.92.7,1.8.18,3.26-.06,3.3-.9.13-5.85,1.45-6.48,2.71s-.79,4.83-2.4,5.95a5.61,5.61,0,0,1-2.8.45A7.93,7.93,0,0,0,335.67,111.82Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M437.87,228.91c-.27.45-.69,1.37-2.55.62s-3.36-.78-4-1.11a10.12,10.12,0,0,0-2.55-1c-.9-.18-1.8.19-2.19-.24s.18-1,.72-1.07a10.93,10.93,0,0,1,1.47,0,8.42,8.42,0,0,0-2.68-.58c-.64.15-1.44.58-1.82,0s.88-1.16,1.57-1.2a7.34,7.34,0,0,1,1.49.11,9.64,9.64,0,0,0-2.57-.51c-.67.09-2,.47-2.18,0s.3-1,1.3-1.13a4,4,0,0,1,.89-.06,9.07,9.07,0,0,1-2.14-.56c-.22-.24-.16-1.08.81-1a43.33,43.33,0,0,1,5.33,1.08c1,.27,2.75,1,5.12,1.67a15.19,15.19,0,0,1,3.79,1.72A2.86,2.86,0,0,1,437.87,228.91Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M433.64,224.6c1.21.51,3.61.81,4.05,1.22a2.86,2.86,0,0,1,.18,3.09c-.27.45-.69,1.37-2.55.62a34.46,34.46,0,0,0-3.8-1c-.07-.51.14-1.22-.38-1.66a29.56,29.56,0,0,0-3.31-2.08c-.63-.35-.52-1.27,0-1.33a13.5,13.5,0,0,1,2.79.81,21.19,21.19,0,0,0,2.88.31Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M439.15,226.44a2,2,0,1,0,.61,2.73A2,2,0,0,0,439.15,226.44Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M462.7,234.14c-.06,1.88-.86,3.17-4.54,2.72s-16.75-4.89-19-6a2.86,2.86,0,0,1-1.8-3.2c.26-.89,1-1.58,2.66-1.26s16.6,3.62,18.35,3.87C461.36,230.64,462.75,232.37,462.7,234.14Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M461.51,233.13c-.15,1.07-1,1.74-4.4,1.16a164.14,164.14,0,0,1-17.49-5.08c-1.55-.64-1.82-1.5-1.53-2s1-.82,2.57-.49,15.36,3.49,17,3.78C460.44,231,461.65,232.12,461.51,233.13Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M458.66,234.08A2.57,2.57,0,1,0,460.6,231,2.57,2.57,0,0,0,458.66,234.08Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M471.22,227.84c.63,1.76,4.95.47,6.71-.16a3.38,3.38,0,1,0-2.29-6.36C473.89,222,470.59,226.08,471.22,227.84Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M476.06,220.62c1.33.3,2.11,6.07,1.69,7.07s-6.8,4.06-10.23,5.67c-3.86,1.81-4.92,2.44-6.16,1.32s-1.48-2.71-1-3.41C461.55,229.31,474.45,220.26,476.06,220.62Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M475,221.47c1.27.08,2.47,4.12,2.15,4.87s-6.08,3.61-9.18,5.12c-3.49,1.7-4.43,2.26-5.69,1.59s-1.61-1.78-1.25-2.32C462,229.19,473.41,221.38,475,221.47Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M500.12,337.06c-11,4.62-16.5.95-24.8-3.85s-9.24-9.52-2.86-12.5c12-5.64,18.9.05,27.2,4.84S506.62,334.34,500.12,337.06Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M486.26,318.13a3.86,3.86,0,0,1,2.55,3.15c.28,1.77.11,4-2.66,4.18s-4.42.6-6,1.81-6.62,1.94-7.82.56.53-2.3,2-3.18a21.28,21.28,0,0,0,5.38-4.29,5.14,5.14,0,0,1,3.12-2.16A6.27,6.27,0,0,1,486.26,318.13Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M484.13,319.26A2.86,2.86,0,0,1,486,321.6c.21,1.31.08,3-2,3.1a7.54,7.54,0,0,0-4.47,1.34c-1.19.9-4.92,1.45-5.82.43s.4-1.71,1.47-2.37a15.71,15.71,0,0,0,4-3.19,3.88,3.88,0,0,1,2.32-1.6A4.62,4.62,0,0,1,484.13,319.26Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M483.36,292.29c.72,1.2,1,4,1.7,7.43s2.3,8,2.05,12.4.74,6.87.11,7.54a2.51,2.51,0,0,1-3,.25c-1.07-.64-1.78-1.1-1.49-1.74s1.66-3,.49-8.21-2.83-12.18-3.43-12.82-1.31-.46-2.06-1.56S482.08,290.16,483.36,292.29Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M487.85,316.85c-.82,1-4.16.27-4.81-.44s-2.24-8.77-3.56-13.32c-1.17-4.08-2.62-7.45-2-8.38s3.22-4.43,5.79-3.17,3.23,7.65,3.89,11.92S488.67,315.87,487.85,316.85Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M485.9,316.73c-.39.89-2.22.39-2.61-.21s-1.7-7.6-2.67-11.54c-.87-3.53-1.84-6.43-1.57-7.26s1.48-4,2.93-3,2.17,6.58,2.77,10.29S486.28,315.84,485.9,316.73Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M498.41,324.63a5.17,5.17,0,0,1,1.2,5.06,18.19,18.19,0,0,1-3.51,6C494.72,337,493,339,490,337.87s-.25-5.49.63-6.62a11.76,11.76,0,0,0,2.27-4.57c.25-1.52.92-1.84,1.74-1.91S497.59,323.71,498.41,324.63Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M497.57,326a3.82,3.82,0,0,1,1.05,4,14.12,14.12,0,0,1-3.06,4.72c-1.21,1-2.72,2.6-5.35,1.73s-.21-4.32.56-5.22a9,9,0,0,0,2-3.6c.21-1.2.8-1.45,1.51-1.51S496.85,325.3,497.57,326Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M496.6,299.39c.74,1.91,1.24,5.59,1.42,9.74s-.08,10.3-.11,12.11a19.12,19.12,0,0,0,.32,3.36,1.91,1.91,0,0,1-2.45,1.77c-1.62-.49-2.54-1.48-2.23-2.4a24.13,24.13,0,0,0,.82-10.13c-.64-5.24-1.6-9.14-1.95-9.67s-1.2-1.17-1.49-1.88S495.08,295.46,496.6,299.39Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M498.68,322.66c-1.1.93-4.32.66-5-.22s-1.73-9.07-2.36-12.79c-.54-3.24-2-6.62-.54-7.6s3.42-3.64,5.85-2.66C498,300,499,311.58,499,314.24,499,318.51,498.68,322.66,498.68,322.66Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M496.63,321.88a1.79,1.79,0,0,1-2.57-.11c-.38-.7-.55-8.24-1.14-10.73s-1.45-4.79-.72-5.6,1.68-2.95,2.94-2.2c.74.45,1.42,9.75,1.47,11.89C496.69,318.55,496.63,321.88,496.63,321.88Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M476.86,292.94a3.21,3.21,0,1,0,3.2-3.2A3.21,3.21,0,0,0,476.86,292.94Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M483.05,290.45a4,4,0,0,1-3.78,3.78c-2.27,0-3.49-2.27-3.59-3.78s1.7-31.63,2.84-34.75,4.34-6.51,8.59-4.62,4.34,7,2.45,11.42a90.89,90.89,0,0,0-4.72,16C484.28,282.05,483.05,288.47,483.05,290.45Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M480.56,289.51c0,1.4-.79,3.3-2,3.3s-1.81-2-1.86-3.3.88-27.63,1.47-30.35,2.25-5.69,4.45-4,2.25,6.1,1.27,10A120.41,120.41,0,0,0,481.49,279C481.19,282.17,480.56,287.78,480.56,289.51Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M487.2,266a9.58,9.58,0,0,1-6.61-7.65c-.41-2.43-1.51-16.06-1.51-16.06s16,.76,16.91,1.8-.45,6.68,1.74,12.49C499.6,261.51,491.49,267.42,487.2,266Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M482.39,217.88c-1.61,0-5.24.19-6.28,2.6s1,6.28,1,6.28-1.8,4.2-1.09,7.18.71,3.4.66,3.68-1.56,5-.28,5.24a8.94,8.94,0,0,1,2.74.42c1,.48,1.5,1.77,3.26,2.94,2,1.36,9.85,4.86,11.94,4.76,4.86-.23,6.23-6.33,7.46-10,1-3.09,1.94-7.41,1.94-7.41s3.06-.47,3-2.6-2.67-3.87-5.12-6a55.41,55.41,0,0,0-6.4-4.72C493.81,219.44,485.31,218,482.39,217.88Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M482.92,218.54c-1.46,0-4.75.17-5.69,2.35s.94,5.69.94,5.69a14.48,14.48,0,0,0-1.88,5.81,10.05,10.05,0,0,0,.65,3.94c0,.25,5.23,3,7.06,3.52,4.75,1.48,9.79-.11,10.9-3.44.94-2.8,7.39-3.67,7.39-3.67s2.78-.43,2.7-2.35-2.42-3.52-4.64-5.4a50.32,50.32,0,0,0-5.8-4.27C493.27,220,485.57,218.62,482.92,218.54Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M489.5,299.92a3.21,3.21,0,1,0,3.2-3.2A3.21,3.21,0,0,0,489.5,299.92Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M496.22,300.13c-1.11.76-5.57-.28-6.84-.42a2,2,0,0,1-1.56-2.08,163.9,163.9,0,0,0,.71-16.71c-.19-7.46-1.75-13.38,0-17.86,1.86-4.65,5.93-7.82,9.69-6.7s4.66,5.28,4.28,9.9c-.44,5.38-6.26,20.89-6.36,25.52S497.4,299.33,496.22,300.13Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M493.8,299.26c-.7.72-3.54-.27-4.35-.41s-1-1.5-1-2,.57-8.89.45-16.05-1.11-12.84,0-17.14c1.18-4.47,3.77-7.51,6.17-6.43s3,5.07,2.72,9.5c-.29,5.16-4,20.05-4.05,24.49S494.55,298.49,493.8,299.26Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M491.36,200.79c2.11,1.12,3.87,3.83,2.41,7.51s-1.82,6.62-1.41,8.18a50.61,50.61,0,0,0,1.89,4.84s-3,2.37-6,2-3.82-1.74-3.82-1.74S483.05,196.4,491.36,200.79Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M492,211.93a5.41,5.41,0,0,1-2.55,4.44c-1.89,1.28-5.24,3.73-7.41,2.55s-2.88-7.54-2.93-9.82c-.06-2.55.57-6.75,3.45-8.4a8.15,8.15,0,0,1,5.85-1.14,9,9,0,0,1,3.68,2.41c.81.8,0,3.21-.42,4.91S492,211.08,492,211.93Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M489,211.47a5.25,5.25,0,0,1-1.84,4c-1.36,1.15-3.78,3.35-5.34,2.29s-2.08-6.77-2.11-8.82c0-2.29.4-6.07,2.48-7.55a4.91,4.91,0,0,1,4.22-1,6.66,6.66,0,0,1,2.66,2.16c.57.73,0,2.89-.31,4.42S489,210.71,489,211.47Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M494.38,251c-2.09.1-9.91-3.4-11.94-4.76-1.76-1.17-2.27-2.46-3.26-2.94a8.94,8.94,0,0,0-2.74-.42c-1.28-.28.23-5,.28-5.24a.28.28,0,0,0,0-.09h0a.41.41,0,0,0,0-.12h0a3.29,3.29,0,0,0,0-.38l1.38.74a31.38,31.38,0,0,0,8.45,3.49c3.86.89,6.53.21,8.86-4.27,1.64-3.16,6.23-2.76,8.35-3.3h0c-.15.71-1,4.49-1.91,7.29C500.61,244.65,499.24,250.75,494.38,251Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M482.11,241.9c-1.93-1-4.83-2.17-5.73-3,.17-.68.33-1.2.34-1.29a2,2,0,0,0,0-.6l1.38.74a31.38,31.38,0,0,0,8.45,3.49c3.86.89,6.53.21,8.86-4.27,1.64-3.16,6.23-2.76,8.35-3.3-.15.71-1,4.49-1.91,7.29-.87,2.6-1.81,6.4-4,8.49a7.75,7.75,0,0,1-.32-2.61c.23-4.77-1.22-7-1.22-7S493.59,247.89,482.11,241.9Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M507.78,278.43c.92.22,1.33.5,1.24,1.41s0,4.17.08,5.58S508,290,508,290a4.76,4.76,0,0,1-.63,1.93c-.5.67-.88.46-1,.3a1.5,1.5,0,0,1,0-1.09,15.1,15.1,0,0,0,.18-2s-.59,2.26-.8,3.1-.77,1.68-1.31,1.72a.64.64,0,0,1-.7-.69,9.76,9.76,0,0,0,.52-1.79c0-.57.05-1.49.05-1.49a12.39,12.39,0,0,1-.73,3.07c-.24.54-.77,2.53-1.74,2-.72-.37.17-2.14.31-2.66a18,18,0,0,0,.29-5.83c-.19-1.22-.63-1.71-1.77-.67s-2.21,1.71-2.46,1.11.81-1.91,1.51-2.73a14.49,14.49,0,0,1,2.72-2.35c1.69-1,1.71-3,2.81-3.53A3.45,3.45,0,0,1,507.78,278.43Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M507.78,278.43c.92.22,1.33.5,1.24,1.41s0,4.17.08,5.58S508,290,508,290a4.76,4.76,0,0,1-.63,1.93c-.5.67-.88.46-1,.3a1.5,1.5,0,0,1,0-1.09,15.1,15.1,0,0,0,.18-2s-.59,2.26-.8,3.1-.77,1.68-1.31,1.72a.64.64,0,0,1-.7-.69,9.76,9.76,0,0,0,.52-1.79c0-.57.05-1.49.05-1.49a12.39,12.39,0,0,1-.73,3.07c-.24.54-.77,2.53-1.74,2-.72-.37.17-2.14.31-2.66a18,18,0,0,0,.29-5.83c-.19-1.22-.63-1.71-1.77-.67s-2.21,1.71-2.46,1.11.81-1.91,1.51-2.73a14.49,14.49,0,0,1,2.72-2.35c1.69-1,1.71-3,2.81-3.53A3.45,3.45,0,0,1,507.78,278.43Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M505.14,278.58a2,2,0,1,0,2.13-1.81A2,2,0,0,0,505.14,278.58Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M509.43,252a3.55,3.55,0,0,1,2,2.33c.6,1.87-1,19.54-1.31,21.29s-.73,4-2.75,3.82-2.64-1.37-2.58-2.61c.08-1.66.2-10.07-.17-15.14-.35-4.69-.25-6.45.29-7.49C505.37,253.39,507.69,251.35,509.43,252Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M508.43,254.73a2.58,2.58,0,0,1,1.31,1.92c.38,1.56-1,16.43-1.18,17.9s-.54,3.4-1.87,3.26a1.82,1.82,0,0,1-1.68-2.17c.08-1.38.28-8.45.11-12.71-.16-3.93-.07-5.41.3-6.29C505.72,255.93,507.29,254.18,508.43,254.73Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M506,232.67a8.07,8.07,0,0,1-3.57,1.12c-1.11,0-2.59.46-2.7,1.5s1.62,1.48,2.1,6.16,2.31,2.66,3.61-.6C506.79,237.42,506.59,233.62,506,232.67Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M505.43,253.55a2.57,2.57,0,1,0,1.94-3.07A2.57,2.57,0,0,0,505.43,253.55Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M510.14,251c0,.85-1.58,1.45-3.07,2.06s-2.51.41-2.59-.37-1.85-7.24-2.64-9.55c-.86-2.55-2.4-4.48-1.14-5.69s4.8-4.19,6.45-3.34S510.16,249.83,510.14,251Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M508.18,250.21c.05.74-.9,1.33-1.8,1.91s-1.55.46-1.66-.22-1.67-6.26-2.33-8.25c-.72-2.2-1.82-3.83-1.12-4.94s2.74-3.83,3.84-3.16S508.11,249.23,508.18,250.21Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M486.33,213.66c.42-3.43-.2-9.68,2.4-11.34a4.2,4.2,0,0,1,3.44-.27c.7.86-.11,3.18-.48,4.83s.33,4.2.33,5.05a5.41,5.41,0,0,1-2.55,4.44c-1.37.92-3.5,2.46-5.39,2.79C484.53,218.12,486,216.56,486.33,213.66Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M410.92,176.06c0,.11,0,.22,0,.33v-.33Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M491.87,272.63c-44.71,0-81-21.11-81-47.14,0-.22,0-.44,0-.65h0V176.39c0,26,36.25,47.14,81,47.14Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M492.37,273.13h-.5c-44.92,0-81.46-21.37-81.46-47.64,0-.13,0-.26,0-.39V176.39h1c0,25.72,36.09,46.65,80.46,46.65h.5Zm-81-48.79h0l0,.51,0,.29c0,.12,0,.23,0,.35,0,25.62,35.83,46.48,80,46.64V224c-40.35-.14-73.84-17.53-80-40.17Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M413.07,226.9l0-23.73,7.33,19.21,11.37-10.53L443,233.71l17.88-4.78,8.45,17.35,13.44,4,4.7,14.38v4.91C447.2,269,414.61,250.28,413.07,226.9Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M414.32,233.41l11.45.53,9.7-5.2,8.29,16.39,13.11-8.68,10.41,19.81,7-3.54,13.25,15.87v1C451,269.08,420.85,253.67,414.32,233.41Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M424.73,240.57l12.16-1,4.95,14.84,16.37-4.68,14,17.93,9.76-2.26,2.42,4.11c-31.85-1.18-58.39-13.75-67.74-30.79Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M575.49,330.79c0,4.6-1.94,16.63-4.32,16.63s-4.32-12-4.32-16.63c0-4.05,1.94-5,4.32-5S575.49,326.74,575.49,330.79Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M575.26,330.74c0,4.48-1.83,16.4-4.09,16.4s-4.09-11.92-4.09-16.4c0-3.95,1.83-4.91,4.09-4.91S575.26,326.79,575.26,330.74Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M575,330.68c0,4.38-1.73,16.18-3.86,16.18s-3.86-11.8-3.86-16.18c0-3.85,1.73-4.78,3.86-4.78S575,326.83,575,330.68Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M574.8,330.62c0,4.27-1.63,16-3.63,16s-3.63-11.69-3.63-16c0-3.75,1.63-4.66,3.63-4.66S574.8,326.87,574.8,330.62Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M574.56,330.57c0,4.16-1.52,15.73-3.39,15.73s-3.4-11.57-3.4-15.73c0-3.66,1.52-4.55,3.4-4.55S574.56,326.91,574.56,330.57Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M574.33,330.51c0,4.05-1.41,15.51-3.16,15.51S568,334.56,568,330.51c0-3.56,1.42-4.42,3.17-4.42S574.33,327,574.33,330.51Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M574.1,330.46c0,3.94-1.31,15.28-2.93,15.28s-2.93-11.34-2.93-15.28c0-3.47,1.31-4.31,2.93-4.31S574.1,327,574.1,330.46Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M573.87,330.4c0,3.83-1.21,15.06-2.7,15.06s-2.7-11.23-2.7-15.06c0-3.37,1.21-4.19,2.7-4.19S573.87,327,573.87,330.4Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M573.64,330.34c0,3.73-1.1,14.84-2.47,14.84s-2.47-11.11-2.47-14.84c0-3.27,1.1-4.06,2.47-4.06S573.64,327.07,573.64,330.34Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M573.41,330.29c0,3.61-1,14.61-2.24,14.61s-2.24-11-2.24-14.61c0-3.18,1-4,2.24-4S573.41,327.11,573.41,330.29Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M573.18,330.23c0,3.51-.9,14.39-2,14.39s-2-10.88-2-14.39c0-3.08.9-3.83,2-3.83S573.18,327.15,573.18,330.23Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M573,330.18c0,3.39-.8,14.16-1.78,14.16s-1.78-10.77-1.78-14.16c0-3,.8-3.71,1.78-3.71S573,327.19,573,330.18Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M574.64,324.52h-6.9v1h0v0c0,1.12,1.54,2,3.45,2s3.45-.9,3.45-2v0h0Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M562.23,301.68c-.54,2.45-3.35,10.82-5.23,10.4s-2.26-9.45-1.59-11.92a3.5,3.5,0,1,1,6.82,1.52Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-122",
    cx: 295.54,
    cy: 262.46,
    rx: 3.45,
    ry: 2.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M586.57,299.3c0,8.5-6.9,26.31-15.4,26.31s-15.4-17.81-15.4-26.31c0-7.49,6.9-9.29,15.4-9.29S586.57,291.81,586.57,299.3Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M586.57,299.3c0,8.5-6.9,26.31-15.4,26.31s-15.4-17.81-15.4-26.31c0-7.49,6.9-9.29,15.4-9.29S586.57,291.81,586.57,299.3Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-125",
    cx: 295.56,
    cy: 236,
    rx: 15.11,
    ry: 8.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-126",
    cx: 295.55,
    cy: 235.94,
    rx: 14.93,
    ry: 8.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-127",
    cx: 295.54,
    cy: 235.88,
    rx: 14.74,
    ry: 8.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128",
    cx: 295.54,
    cy: 235.83,
    rx: 14.56,
    ry: 8.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-129",
    cx: 295.53,
    cy: 235.77,
    rx: 14.38,
    ry: 8.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-130",
    cx: 295.53,
    cy: 235.71,
    rx: 14.2,
    ry: 8.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 295.52,
    cy: 235.65,
    rx: 14.02,
    ry: 8.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-132",
    cx: 295.52,
    cy: 235.59,
    rx: 13.83,
    ry: 8.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-133",
    cx: 295.51,
    cy: 235.53,
    rx: 13.65,
    ry: 7.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-134",
    cx: 295.5,
    cy: 235.47,
    rx: 13.47,
    ry: 7.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-135",
    cx: 295.5,
    cy: 235.41,
    rx: 13.29,
    ry: 7.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-136",
    cx: 295.49,
    cy: 235.35,
    rx: 13.11,
    ry: 7.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-137",
    cx: 297.27,
    cy: 233.66,
    rx: 13.1,
    ry: 7.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-138",
    cx: 297.24,
    cy: 233.69,
    rx: 12.77,
    ry: 7.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-139",
    cx: 297.21,
    cy: 233.71,
    rx: 12.43,
    ry: 7.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-140",
    cx: 297.18,
    cy: 233.73,
    rx: 12.09,
    ry: 7.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-141",
    cx: 297.15,
    cy: 233.75,
    rx: 11.75,
    ry: 6.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-142",
    cx: 297.12,
    cy: 233.77,
    rx: 11.42,
    ry: 6.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M583.82,295.87c0,3.57-5,6.46-11.08,6.46s-11.08-2.89-11.08-6.46,5-6.45,11.08-6.45S583.82,292.31,583.82,295.87Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M583.45,295.9c0,3.45-4.8,6.25-10.74,6.25S562,299.35,562,295.9s4.81-6.26,10.74-6.26S583.45,292.44,583.45,295.9Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-145",
    cx: 297.03,
    cy: 233.84,
    rx: 10.41,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M582.72,295.94c0,3.24-4.51,5.86-10.07,5.86s-10.07-2.62-10.07-5.86,4.51-5.86,10.07-5.86S582.72,292.7,582.72,295.94Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M582.36,296c0,3.13-4.36,5.67-9.74,5.67s-9.73-2.54-9.73-5.67,4.36-5.66,9.73-5.66S582.36,292.83,582.36,296Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-148",
    cx: 296.94,
    cy: 233.91,
    rx: 9.39,
    ry: 5.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-149",
    cx: 571.25,
    cy: 283.62,
    r: 18.08,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -76.34, 739.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M554.64,285.22h0a24.49,24.49,0,0,0,15,8.59h0a2.6,2.6,0,0,0,3-2.56v-4.72a4.78,4.78,0,0,0-3.4-4.57h0a26.56,26.56,0,0,1-11.2-6.78h0a1.56,1.56,0,0,0-2.49.35,17.58,17.58,0,0,0-1.94,6.23A4.61,4.61,0,0,0,554.64,285.22Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M559.32,283c0,.86-.6,1.2-1.35.77a3,3,0,0,1-1.35-2.33c0-.85.61-1.19,1.35-.76A3,3,0,0,1,559.32,283Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M567.08,287.51c0,.85-.6,1.2-1.35.77a3,3,0,0,1-1.35-2.33c0-.85.61-1.2,1.35-.77A3,3,0,0,1,567.08,287.51Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-152",
    cx: 306.26,
    cy: 246.95,
    r: 4.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M585.67,310.89c-.53,3.16-5,10.11-6.86,9.7s-.2-9,.34-11.43a3.42,3.42,0,0,1,4.15-2.81C585.19,306.77,586,308.72,585.67,310.89Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M585.67,310.89c-.53,3.16-5,10.11-6.86,9.7s-.2-9,.34-11.43a3.42,3.42,0,0,1,4.15-2.81C585.19,306.77,586,308.72,585.67,310.89Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M582.55,310.11c-.19,2.5-3.1,9.53-3.7,9.49s.4-6.39.74-9.08c.28-2.19.95-3.3,1.52-3.49C582.75,306.5,582.71,307.91,582.55,310.11Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M585.28,311.22c-.77,3.7-4.58,8.62-5.18,8.5s2.8-5.07,3.46-7.7c.53-2.14,0-4.32.61-4.44C585.86,307.24,585.73,309.06,585.28,311.22Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M576.59,268.1H565.78v.79h0v0c0,1.74,2.42,3.15,5.4,3.15s5.41-1.41,5.41-3.15v0h0Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-158",
    cx: 295.53,
    cy: 206.05,
    rx: 5.41,
    ry: 3.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M572,260.66h-1.61v7.12h0c0,.26.36.47.8.47s.81-.21.81-.47h0Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M573.59,260.86a2.41,2.41,0,1,1-2.41-2.4A2.41,2.41,0,0,1,573.59,260.86Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-161",
    cx: 291.87,
    cy: 216.4,
    r: 11.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M563,282.12a5.07,5.07,0,1,1-5.06-5.06A5.07,5.07,0,0,1,563,282.12Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M570.87,286.78a5.07,5.07,0,1,1-5.06-5.06A5.07,5.07,0,0,1,570.87,286.78Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M563.16,305.82c2.05,8.26,6.31,17.76,5.3,18.22-1.78.8-8.78-8.53-10.84-16.78-1.8-7.26-1-15.8.93-16.27S561.35,298.56,563.16,305.82Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M558.71,294.08l-1.3-2.24c-.26-.45,0-.78.36-.44l1.77,1.75a3,3,0,0,0,1.5.86l1.77.3c.35.06.62.71.36.85l-1.3.74C561,296.4,559.58,295.58,558.71,294.08Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "295.2 284.29 292.8 282.9 295.19 281.52 297.6 282.91 295.2 284.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "298.89 286.42 296.48 285.03 298.88 283.65 301.28 285.04 298.89 286.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "302.58 288.55 300.17 287.16 302.56 285.78 304.97 287.17 302.58 288.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "306.26 290.68 303.86 289.29 306.25 287.91 308.66 289.3 306.26 290.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "309.95 292.81 307.54 291.42 309.94 290.04 312.34 291.43 309.95 292.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "313.64 294.94 311.23 293.55 313.62 292.16 316.03 293.55 313.64 294.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "317.32 297.06 314.92 295.67 317.31 294.29 319.72 295.68 317.32 297.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "291.56 286.39 289.16 285.01 291.55 283.62 293.96 285.01 291.56 286.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "295.25 288.52 292.84 287.13 295.24 285.75 297.64 287.14 295.25 288.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "298.94 290.65 296.53 289.26 298.92 287.88 301.33 289.27 298.94 290.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "302.62 292.78 300.22 291.39 302.61 290.01 305.01 291.4 302.62 292.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "306.31 294.91 303.9 293.52 306.3 292.14 308.7 293.53 306.31 294.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "310 297.04 307.59 295.65 309.98 294.27 312.39 295.66 310 297.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "313.68 299.17 311.28 297.78 313.67 296.39 316.07 297.79 313.68 299.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "302.49 280.07 300.08 278.69 302.47 277.3 304.88 278.69 302.49 280.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "306.17 282.2 303.77 280.81 306.16 279.43 308.56 280.82 306.17 282.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "309.86 284.33 307.45 282.94 309.84 281.56 312.25 282.95 309.86 284.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "313.55 286.46 311.14 285.07 313.53 283.69 315.94 285.08 313.55 286.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "317.23 288.59 314.82 287.2 317.22 285.82 319.62 287.21 317.23 288.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "320.92 290.72 318.51 289.33 320.9 287.95 323.31 289.33 320.92 290.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "324.61 292.85 322.2 291.45 324.59 290.07 327 291.46 324.61 292.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "298.85 282.18 296.44 280.79 298.83 279.41 301.24 280.8 298.85 282.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "302.53 284.31 300.13 282.92 302.52 281.53 304.92 282.92 302.53 284.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "306.22 286.43 303.81 285.04 306.2 283.66 308.61 285.05 306.22 286.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "309.9 288.56 307.5 287.17 309.89 285.79 312.3 287.18 309.9 288.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "313.59 290.69 311.18 289.3 313.58 287.92 315.98 289.31 313.59 290.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "317.28 292.82 314.87 291.43 317.26 290.05 319.67 291.44 317.28 292.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "320.96 294.95 318.56 293.56 320.95 292.18 323.36 293.57 320.96 294.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "287.92 288.5 285.52 287.11 287.91 285.73 290.31 287.12 287.92 288.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "291.61 290.63 289.2 289.24 291.59 287.86 294 289.25 291.61 290.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "295.3 292.75 292.89 291.36 295.28 289.98 297.69 291.37 295.3 292.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "298.98 294.88 296.57 293.49 298.97 292.11 301.37 293.5 298.98 294.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "302.67 297.01 300.26 295.62 302.65 294.24 305.06 295.63 302.67 297.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "306.36 299.14 303.95 297.75 306.34 296.37 308.75 297.76 306.36 299.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "310.04 301.27 307.63 299.88 310.03 298.5 312.43 299.89 310.04 301.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "284.28 290.6 281.88 289.21 284.27 287.83 286.67 289.22 284.28 290.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "287.97 292.73 285.56 291.34 287.95 289.96 290.36 291.35 287.97 292.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "291.65 294.86 289.25 293.47 291.64 292.09 294.05 293.48 291.65 294.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "295.34 296.99 292.93 295.6 295.33 294.21 297.73 295.6 295.34 296.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "299.03 299.11 296.62 297.72 299.01 296.34 301.42 297.73 299.03 299.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "302.71 301.24 300.31 299.85 302.7 298.47 305.11 299.86 302.71 301.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "306.4 303.37 303.99 301.98 306.39 300.6 308.79 301.99 306.4 303.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "280.64 292.7 278.23 291.31 280.63 289.93 283.03 291.32 280.64 292.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "284.33 294.83 281.92 293.44 284.31 292.06 286.72 293.45 284.33 294.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "288.01 296.96 285.61 295.57 288 294.19 290.41 295.58 288.01 296.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "291.7 299.09 289.29 297.7 291.69 296.32 294.09 297.71 291.7 299.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "295.39 301.21 292.98 299.83 295.37 298.44 297.78 299.83 295.39 301.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "299.07 303.34 296.67 301.95 299.06 300.57 301.46 301.96 299.07 303.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "302.76 305.47 300.35 304.08 302.75 302.7 305.15 304.09 302.76 305.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "277 294.8 274.59 293.41 276.99 292.03 279.39 293.42 277 294.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "280.69 296.93 278.28 295.54 280.67 294.16 283.08 295.55 280.69 296.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "284.37 299.06 281.97 297.67 284.36 296.29 286.76 297.68 284.37 299.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "288.06 301.19 285.65 299.8 288.04 298.42 290.45 299.81 288.06 301.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "291.75 303.32 289.34 301.93 291.73 300.55 294.14 301.94 291.75 303.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "295.43 305.45 293.02 304.06 295.42 302.68 297.82 304.06 295.43 305.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "299.12 307.57 296.71 306.19 299.1 304.8 301.51 306.19 299.12 307.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "273.36 296.91 270.95 295.52 273.34 294.13 275.75 295.52 273.36 296.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "277.05 299.03 274.64 297.64 277.03 296.26 279.44 297.65 277.05 299.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "280.73 301.16 278.32 299.77 280.72 298.39 283.12 299.78 280.73 301.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "284.42 303.29 282.01 301.9 284.4 300.52 286.81 301.91 284.42 303.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "288.11 305.42 285.7 304.03 288.09 302.65 290.5 304.04 288.11 305.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "291.79 307.55 289.38 306.16 291.78 304.78 294.18 306.17 291.79 307.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "295.48 309.68 293.07 308.29 295.46 306.91 297.87 308.3 295.48 309.68"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "210.5 256.55 208.09 255.16 210.49 253.78 212.89 255.17 210.5 256.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "214.19 258.68 211.78 257.29 214.17 255.91 216.58 257.3 214.19 258.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "217.87 260.81 215.47 259.42 217.86 258.04 220.26 259.43 217.87 260.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "221.56 262.94 219.15 261.55 221.54 260.17 223.95 261.56 221.56 262.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "225.25 265.07 222.84 263.68 225.23 262.3 227.64 263.69 225.25 265.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "228.93 267.2 226.53 265.81 228.92 264.43 231.32 265.81 228.93 267.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "232.62 269.32 230.21 267.94 232.6 266.55 235.01 267.94 232.62 269.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "206.86 258.66 204.45 257.27 206.84 255.88 209.25 257.27 206.86 258.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "210.54 260.78 208.14 259.39 210.53 258.01 212.94 259.4 210.54 260.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "214.23 262.91 211.82 261.52 214.22 260.14 216.62 261.53 214.23 262.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "217.92 265.04 215.51 263.65 217.9 262.27 220.31 263.66 217.92 265.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "221.6 267.17 219.2 265.78 221.59 264.4 224 265.79 221.6 267.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "225.29 269.3 222.88 267.91 225.28 266.53 227.68 267.92 225.29 269.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "228.98 271.43 226.57 270.04 228.96 268.66 231.37 270.05 228.98 271.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "217.78 252.34 215.37 250.94 217.77 249.56 220.17 250.95 217.78 252.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "221.47 254.46 219.06 253.07 221.45 251.69 223.86 253.08 221.47 254.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "225.15 256.59 222.75 255.2 225.14 253.82 227.55 255.21 225.15 256.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "228.84 258.72 226.43 257.33 228.83 255.95 231.23 257.34 228.84 258.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "232.53 260.85 230.12 259.46 232.51 258.08 234.92 259.47 232.53 260.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "236.21 262.98 233.81 261.59 236.2 260.21 238.61 261.6 236.21 262.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "239.9 265.11 237.49 263.72 239.88 262.33 242.29 263.72 239.9 265.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "214.14 254.44 211.73 253.05 214.13 251.67 216.53 253.06 214.14 254.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "217.83 256.57 215.42 255.18 217.81 253.79 220.22 255.19 217.83 256.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "221.51 258.69 219.11 257.3 221.5 255.92 223.91 257.31 221.51 258.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "225.2 260.82 222.79 259.43 225.18 258.05 227.59 259.44 225.2 260.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "228.89 262.95 226.48 261.56 228.87 260.18 231.28 261.57 228.89 262.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "232.57 265.08 230.17 263.69 232.56 262.31 234.96 263.7 232.57 265.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "236.26 267.21 233.85 265.82 236.24 264.44 238.65 265.83 236.26 267.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "203.22 260.76 200.81 259.37 203.2 257.99 205.61 259.38 203.22 260.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "206.9 262.89 204.5 261.5 206.89 260.12 209.3 261.51 206.9 262.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "210.59 265.01 208.18 263.63 210.58 262.24 212.98 263.63 210.59 265.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "214.28 267.14 211.87 265.75 214.26 264.37 216.67 265.76 214.28 267.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "217.96 269.27 215.56 267.88 217.95 266.5 220.36 267.89 217.96 269.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "221.65 271.4 219.24 270.01 221.63 268.63 224.04 270.02 221.65 271.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "225.34 273.53 222.93 272.14 225.32 270.76 227.73 272.15 225.34 273.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "199.58 262.86 197.17 261.47 199.56 260.09 201.97 261.48 199.58 262.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "203.26 264.99 200.86 263.6 203.25 262.22 205.66 263.61 203.26 264.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "206.95 267.12 204.54 265.73 206.94 264.35 209.34 265.74 206.95 267.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "210.64 269.25 208.23 267.86 210.62 266.48 213.03 267.86 210.64 269.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "214.32 271.37 211.92 269.98 214.31 268.6 216.72 269.99 214.32 271.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "218.01 273.5 215.6 272.11 217.99 270.73 220.4 272.12 218.01 273.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "221.7 275.63 219.29 274.24 221.68 272.86 224.09 274.25 221.7 275.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "195.94 264.96 193.53 263.57 195.92 262.19 198.33 263.58 195.94 264.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "199.62 267.09 197.22 265.7 199.61 264.32 202.01 265.71 199.62 267.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "203.31 269.22 200.9 267.83 203.29 266.45 205.7 267.84 203.31 269.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "207 271.35 204.59 269.96 206.98 268.58 209.39 269.97 207 271.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "210.68 273.48 208.28 272.09 210.67 270.7 213.07 272.1 210.68 273.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "214.37 275.61 211.96 274.21 214.35 272.83 216.76 274.22 214.37 275.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "218.06 277.73 215.65 276.34 218.04 274.96 220.45 276.35 218.06 277.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "192.29 267.06 189.89 265.68 192.28 264.29 194.69 265.68 192.29 267.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "195.98 269.19 193.57 267.8 195.97 266.42 198.37 267.81 195.98 269.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "199.67 271.32 197.26 269.93 199.65 268.55 202.06 269.94 199.67 271.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "203.35 273.45 200.95 272.06 203.34 270.68 205.75 272.07 203.35 273.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "207.04 275.58 204.63 274.19 207.03 272.81 209.43 274.2 207.04 275.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "210.73 277.71 208.32 276.32 210.71 274.94 213.12 276.33 210.73 277.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "214.41 279.83 212.01 278.44 214.4 277.06 216.81 278.45 214.41 279.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "188.65 269.17 186.25 267.78 188.64 266.4 191.04 267.79 188.65 269.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "192.34 271.3 189.93 269.9 192.32 268.52 194.73 269.91 192.34 271.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "196.03 273.42 193.62 272.03 196.01 270.65 198.42 272.04 196.03 273.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "199.71 275.55 197.31 274.16 199.7 272.78 202.1 274.17 199.71 275.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "203.4 277.68 200.99 276.29 203.38 274.91 205.79 276.3 203.4 277.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "207.09 279.81 204.68 278.42 207.07 277.04 209.48 278.43 207.09 279.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "210.77 281.94 208.37 280.55 210.76 279.17 213.16 280.56 210.77 281.94"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "162.89 212.42 160.49 211.03 162.88 209.65 165.29 211.04 162.89 212.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "159.25 214.52 156.85 213.13 159.24 211.75 161.65 213.14 159.25 214.52"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "170.18 208.2 167.77 206.81 170.16 205.43 172.57 206.82 170.18 208.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "166.53 210.3 164.13 208.91 166.52 207.53 168.93 208.92 166.53 210.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "155.61 216.63 153.21 215.24 155.6 213.85 158 215.24 155.61 216.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "151.97 218.73 149.56 217.34 151.96 215.96 154.36 217.35 151.97 218.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "148.33 220.83 145.92 219.44 148.31 218.06 150.72 219.45 148.33 220.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "144.69 222.93 142.28 221.54 144.67 220.16 147.08 221.55 144.69 222.93"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "141.05 225.03 138.64 223.64 141.03 222.26 143.44 223.65 141.05 225.03"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "151.94 222.98 149.53 221.59 151.92 220.21 154.33 221.6 151.94 222.98"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "148.29 225.09 145.89 223.7 148.28 222.31 150.69 223.7 148.29 225.09"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "159.22 218.76 156.81 217.38 159.2 215.99 161.61 217.38 159.22 218.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "155.58 220.87 153.17 219.48 155.56 218.1 157.97 219.49 155.58 220.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "144.65 227.19 142.25 225.8 144.64 224.42 147.04 225.81 144.65 227.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "141.01 229.29 138.6 227.9 141 226.52 143.4 227.91 141.01 229.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "137.37 231.39 134.96 230 137.36 228.62 139.76 230.01 137.37 231.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "133.73 233.49 131.32 232.1 133.72 230.72 136.12 232.11 133.73 233.49"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "130.09 235.6 127.68 234.21 130.07 232.82 132.48 234.22 130.09 235.6"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "104.44 233.37 102.03 231.98 104.42 230.59 106.83 231.98 104.44 233.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "108.12 235.49 105.72 234.1 108.11 232.72 110.52 234.11 108.12 235.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.81 237.62 109.4 236.23 111.8 234.85 114.2 236.24 111.81 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "115.5 239.75 113.09 238.36 115.48 236.98 117.89 238.37 115.5 239.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "119.18 241.88 116.78 240.49 119.17 239.11 121.58 240.5 119.18 241.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "122.87 244.01 120.46 242.62 122.86 241.24 125.26 242.63 122.87 244.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "126.56 246.14 124.15 244.75 126.54 243.37 128.95 244.75 126.56 246.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.8 235.47 98.39 234.08 100.78 232.7 103.19 234.09 100.8 235.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "104.48 237.6 102.08 236.21 104.47 234.82 106.87 236.22 104.48 237.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "108.17 239.72 105.76 238.34 108.15 236.95 110.56 238.34 108.17 239.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.86 241.85 109.45 240.46 111.84 239.08 114.25 240.47 111.86 241.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "115.54 243.98 113.14 242.59 115.53 241.21 117.93 242.6 115.54 243.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "119.23 246.11 116.82 244.72 119.21 243.34 121.62 244.73 119.23 246.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "122.92 248.24 120.51 246.85 122.9 245.47 125.31 246.86 122.92 248.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "111.72 229.15 109.31 227.76 111.7 226.38 114.11 227.77 111.72 229.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "115.41 231.28 113 229.88 115.39 228.5 117.8 229.89 115.41 231.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "119.09 233.4 116.68 232.01 119.08 230.63 121.48 232.02 119.09 233.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "122.78 235.53 120.37 234.14 122.76 232.76 125.17 234.15 122.78 235.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "126.46 237.66 124.06 236.27 126.45 234.89 128.86 236.28 126.46 237.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "130.15 239.79 127.74 238.4 130.14 237.02 132.54 238.41 130.15 239.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "133.84 241.92 131.43 240.53 133.82 239.15 136.23 240.54 133.84 241.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "108.08 231.25 105.67 229.86 108.06 228.48 110.47 229.87 108.08 231.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.76 233.38 109.36 231.99 111.75 230.61 114.16 232 111.76 233.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "115.45 235.51 113.04 234.12 115.44 232.74 117.84 234.13 115.45 235.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "119.14 237.63 116.73 236.24 119.12 234.86 121.53 236.25 119.14 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "122.82 239.76 120.42 238.37 122.81 236.99 125.22 238.38 122.82 239.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "126.51 241.89 124.1 240.5 126.5 239.12 128.9 240.51 126.51 241.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "130.2 244.02 127.79 242.63 130.18 241.25 132.59 242.64 130.2 244.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "97.16 237.57 94.75 236.18 97.14 234.8 99.55 236.19 97.16 237.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.84 239.7 98.43 238.31 100.83 236.93 103.23 238.32 100.84 239.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "104.53 241.83 102.12 240.44 104.51 239.06 106.92 240.45 104.53 241.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "108.21 243.96 105.81 242.56 108.2 241.18 110.61 242.57 108.21 243.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.9 246.08 109.49 244.69 111.89 243.31 114.29 244.7 111.9 246.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "115.59 248.21 113.18 246.82 115.57 245.44 117.98 246.83 115.59 248.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "119.27 250.34 116.87 248.95 119.26 247.57 121.67 248.96 119.27 250.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "93.51 239.67 91.11 238.28 93.5 236.9 95.91 238.29 93.51 239.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "97.2 241.8 94.79 240.41 97.19 239.03 99.59 240.42 97.2 241.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "100.89 243.93 98.48 242.54 100.87 241.16 103.28 242.55 100.89 243.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "104.57 246.06 102.17 244.67 104.56 243.29 106.97 244.68 104.57 246.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "108.26 248.19 105.85 246.8 108.25 245.41 110.65 246.8 108.26 248.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.95 250.31 109.54 248.92 111.93 247.54 114.34 248.93 111.95 250.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "115.63 252.44 113.23 251.05 115.62 249.67 118.03 251.06 115.63 252.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "89.87 241.77 87.47 240.38 89.86 239 92.27 240.39 89.87 241.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "93.56 243.9 91.15 242.51 93.54 241.13 95.95 242.52 93.56 243.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "97.25 246.03 94.84 244.64 97.23 243.26 99.64 244.65 97.25 246.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "100.93 248.16 98.53 246.77 100.92 245.39 103.32 246.78 100.93 248.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "104.62 250.29 102.21 248.9 104.6 247.52 107.01 248.91 104.62 250.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "108.31 252.42 105.9 251.03 108.29 249.65 110.7 251.03 108.31 252.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.99 254.54 109.58 253.16 111.98 251.77 114.38 253.16 111.99 254.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "86.23 243.88 83.83 242.49 86.22 241.1 88.62 242.5 86.23 243.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "89.92 246 87.51 244.62 89.9 243.23 92.31 244.62 89.92 246"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "93.61 248.13 91.2 246.74 93.59 245.36 96 246.75 93.61 248.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "97.29 250.26 94.88 248.87 97.28 247.49 99.68 248.88 97.29 250.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "100.98 252.39 98.57 251 100.96 249.62 103.37 251.01 100.98 252.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "104.66 254.52 102.26 253.13 104.65 251.75 107.06 253.14 104.66 254.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "108.35 256.65 105.94 255.26 108.34 253.88 110.74 255.27 108.35 256.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "82.59 245.98 80.18 244.59 82.58 243.21 84.98 244.6 82.59 245.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "86.28 248.11 83.87 246.72 86.26 245.34 88.67 246.73 86.28 248.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "89.96 250.24 87.56 248.85 89.95 247.46 92.36 248.85 89.96 250.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "93.65 252.36 91.24 250.97 93.64 249.59 96.04 250.98 93.65 252.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "97.34 254.49 94.93 253.1 97.32 251.72 99.73 253.11 97.34 254.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "101.02 256.62 98.62 255.23 101.01 253.85 103.42 255.24 101.02 256.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "104.71 258.75 102.3 257.36 104.69 255.98 107.1 257.37 104.71 258.75"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "103.85 190.84 101.45 189.45 103.84 188.07 106.25 189.46 103.85 190.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "107.54 192.97 105.13 191.58 107.53 190.2 109.93 191.59 107.54 192.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.23 195.1 108.82 193.71 111.21 192.33 113.62 193.72 111.23 195.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "114.91 197.23 112.51 195.84 114.9 194.46 117.31 195.85 114.91 197.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "118.6 199.36 116.19 197.97 118.58 196.59 120.99 197.98 118.6 199.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "122.29 201.49 119.88 200.1 122.27 198.72 124.68 200.1 122.29 201.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "125.97 203.61 123.57 202.22 125.96 200.84 128.37 202.23 125.97 203.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.21 192.95 97.81 191.56 100.2 190.18 102.61 191.56 100.21 192.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "103.9 195.07 101.49 193.69 103.88 192.3 106.29 193.69 103.9 195.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "107.59 197.2 105.18 195.81 107.57 194.43 109.98 195.82 107.59 197.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.27 199.33 108.86 197.94 111.26 196.56 113.66 197.95 111.27 199.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "114.96 201.46 112.55 200.07 114.94 198.69 117.35 200.08 114.96 201.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "118.64 203.59 116.24 202.2 118.63 200.82 121.04 202.21 118.64 203.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "122.33 205.72 119.92 204.33 122.32 202.95 124.72 204.34 122.33 205.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "111.14 186.63 108.73 185.24 111.12 183.85 113.53 185.24 111.14 186.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "114.82 188.75 112.42 187.36 114.81 185.98 117.21 187.37 114.82 188.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "118.51 190.88 116.1 189.49 118.49 188.11 120.9 189.5 118.51 190.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "122.19 193.01 119.79 191.62 122.18 190.24 124.59 191.63 122.19 193.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "125.88 195.14 123.47 193.75 125.87 192.37 128.27 193.76 125.88 195.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "129.57 197.27 127.16 195.88 129.55 194.5 131.96 195.89 129.57 197.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "133.25 199.4 130.85 198.01 133.24 196.63 135.65 198.01 133.25 199.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "107.49 188.73 105.09 187.34 107.48 185.96 109.89 187.35 107.49 188.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.18 190.86 108.77 189.47 111.17 188.09 113.57 189.47 111.18 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "114.87 192.98 112.46 191.59 114.85 190.21 117.26 191.6 114.87 192.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "118.55 195.11 116.15 193.72 118.54 192.34 120.95 193.73 118.55 195.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "122.24 197.24 119.83 195.85 122.22 194.47 124.63 195.86 122.24 197.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "125.93 199.37 123.52 197.98 125.91 196.6 128.32 197.99 125.93 199.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "129.61 201.5 127.21 200.11 129.6 198.73 132 200.12 129.61 201.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "96.57 195.05 94.17 193.66 96.56 192.28 98.96 193.67 96.57 195.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.26 197.18 97.85 195.79 100.24 194.41 102.65 195.8 100.26 197.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "103.94 199.31 101.54 197.91 103.93 196.53 106.34 197.92 103.94 199.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "107.63 201.43 105.22 200.04 107.62 198.66 110.02 200.05 107.63 201.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.32 203.56 108.91 202.17 111.3 200.79 113.71 202.18 111.32 203.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "115 205.69 112.6 204.3 114.99 202.92 117.4 204.31 115 205.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "118.69 207.82 116.28 206.43 118.68 205.05 121.08 206.44 118.69 207.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "92.93 197.15 90.52 195.76 92.92 194.38 95.32 195.77 92.93 197.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "96.62 199.28 94.21 197.89 96.6 196.51 99.01 197.9 96.62 199.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "100.3 201.41 97.9 200.02 100.29 198.64 102.7 200.03 100.3 201.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "103.99 203.54 101.58 202.15 103.97 200.76 106.38 202.16 103.99 203.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "107.68 205.66 105.27 204.27 107.66 202.89 110.07 204.28 107.68 205.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.36 207.79 108.96 206.4 111.35 205.02 113.75 206.41 111.36 207.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "115.05 209.92 112.64 208.53 115.03 207.15 117.44 208.54 115.05 209.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "89.29 199.25 86.88 197.86 89.28 196.48 91.68 197.87 89.29 199.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "92.98 201.38 90.57 199.99 92.96 198.61 95.37 200 92.98 201.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "96.66 203.51 94.26 202.12 96.65 200.74 99.06 202.13 96.66 203.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "100.35 205.64 97.94 204.25 100.33 202.87 102.74 204.26 100.35 205.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "104.04 207.77 101.63 206.38 104.02 205 106.43 206.38 104.04 207.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "107.72 209.9 105.31 208.5 107.71 207.12 110.11 208.51 107.72 209.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "111.41 212.02 109 210.63 111.39 209.25 113.8 210.64 111.41 212.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "85.65 201.35 83.24 199.97 85.63 198.58 88.04 199.97 85.65 201.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "89.33 203.48 86.93 202.09 89.32 200.71 91.73 202.1 89.33 203.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "93.02 205.61 90.61 204.22 93.01 202.84 95.41 204.23 93.02 205.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "96.71 207.74 94.3 206.35 96.69 204.97 99.1 206.36 96.71 207.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "100.39 209.87 97.99 208.48 100.38 207.1 102.79 208.49 100.39 209.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "104.08 212 101.67 210.61 104.07 209.23 106.47 210.62 104.08 212"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "107.77 214.13 105.36 212.74 107.75 211.35 110.16 212.74 107.77 214.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "82.01 203.46 79.6 202.07 81.99 200.69 84.4 202.08 82.01 203.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "85.69 205.59 83.29 204.2 85.68 202.81 88.09 204.2 85.69 205.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "89.38 207.71 86.97 206.32 89.37 204.94 91.77 206.33 89.38 207.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "93.07 209.84 90.66 208.45 93.05 207.07 95.46 208.46 93.07 209.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "96.75 211.97 94.35 210.58 96.74 209.2 99.15 210.59 96.75 211.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "100.44 214.1 98.03 212.71 100.42 211.33 102.83 212.72 100.44 214.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "104.13 216.23 101.72 214.84 104.11 213.46 106.52 214.85 104.13 216.23"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "59.69 148.44 57.29 147.05 59.68 145.66 62.09 147.05 59.69 148.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "63.38 150.56 60.97 149.17 63.37 147.79 65.77 149.18 63.38 150.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "67.07 152.69 64.66 151.3 67.05 149.92 69.46 151.31 67.07 152.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "70.75 154.82 68.35 153.43 70.74 152.05 73.14 153.44 70.75 154.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "74.44 156.95 72.03 155.56 74.42 154.18 76.83 155.57 74.44 156.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "78.13 159.08 75.72 157.69 78.11 156.31 80.52 157.7 78.13 159.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "81.81 161.21 79.41 159.82 81.8 158.44 84.2 159.82 81.81 161.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "56.05 150.54 53.65 149.15 56.04 147.77 58.44 149.16 56.05 150.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "59.74 152.67 57.33 151.28 59.72 149.9 62.13 151.28 59.74 152.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "63.43 154.79 61.02 153.41 63.41 152.02 65.82 153.41 63.43 154.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "67.11 156.92 64.7 155.53 67.1 154.15 69.5 155.54 67.11 156.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "70.8 159.05 68.39 157.66 70.78 156.28 73.19 157.67 70.8 159.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "74.48 161.18 72.08 159.79 74.47 158.41 76.88 159.8 74.48 161.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "78.17 163.31 75.77 161.92 78.16 160.54 80.56 161.93 78.17 163.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "66.97 144.22 64.57 142.83 66.96 141.45 69.37 142.84 66.97 144.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "70.66 146.34 68.25 144.96 70.65 143.57 73.05 144.96 70.66 146.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "74.35 148.47 71.94 147.08 74.33 145.7 76.74 147.09 74.35 148.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "78.03 150.6 75.63 149.21 78.02 147.83 80.43 149.22 78.03 150.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "81.72 152.73 79.31 151.34 81.71 149.96 84.11 151.35 81.72 152.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "85.41 154.86 83 153.47 85.39 152.09 87.8 153.48 85.41 154.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "89.09 156.99 86.69 155.6 89.08 154.22 91.49 155.61 89.09 156.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "63.33 146.32 60.93 144.93 63.32 143.55 65.73 144.94 63.33 146.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "67.02 148.45 64.61 147.06 67 145.68 69.41 147.07 67.02 148.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "70.71 150.57 68.3 149.19 70.69 147.81 73.1 149.19 70.71 150.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "74.39 152.7 71.99 151.31 74.38 149.93 76.78 151.32 74.39 152.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "78.08 154.83 75.67 153.44 78.06 152.06 80.47 153.45 78.08 154.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "81.77 156.96 79.36 155.57 81.75 154.19 84.16 155.58 81.77 156.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "85.45 159.09 83.05 157.7 85.44 156.32 87.84 157.71 85.45 159.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "52.41 152.64 50.01 151.25 52.4 149.87 54.8 151.26 52.41 152.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "56.1 154.77 53.69 153.38 56.08 152 58.49 153.39 56.1 154.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "59.78 156.9 57.38 155.51 59.77 154.13 62.18 155.51 59.78 156.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "63.47 159.03 61.06 157.63 63.46 156.25 65.86 157.64 63.47 159.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "67.16 161.15 64.75 159.76 67.14 158.38 69.55 159.77 67.16 161.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "70.84 163.28 68.44 161.89 70.83 160.51 73.24 161.9 70.84 163.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "74.53 165.41 72.12 164.02 74.52 162.64 76.92 164.03 74.53 165.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "48.77 154.74 46.36 153.35 48.76 151.97 51.16 153.36 48.77 154.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "52.46 156.87 50.05 155.48 52.44 154.1 54.85 155.49 52.46 156.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "56.14 159 53.74 157.61 56.13 156.23 58.53 157.62 56.14 159"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "59.83 161.13 57.42 159.74 59.81 158.36 62.22 159.75 59.83 161.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "63.52 163.25 61.11 161.87 63.5 160.49 65.91 161.87 63.52 163.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "67.2 165.38 64.8 163.99 67.19 162.61 69.59 164 67.2 165.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "70.89 167.51 68.48 166.12 70.88 164.74 73.28 166.13 70.89 167.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "45.13 156.84 42.72 155.45 45.11 154.07 47.52 155.46 45.13 156.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "48.82 158.97 46.41 157.58 48.8 156.2 51.21 157.59 48.82 158.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "52.5 161.1 50.09 159.71 52.49 158.33 54.89 159.72 52.5 161.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "56.19 163.23 53.78 161.84 56.17 160.46 58.58 161.85 56.19 163.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "59.88 165.36 57.47 163.97 59.86 162.59 62.27 163.98 59.88 165.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "63.56 167.49 61.16 166.1 63.55 164.72 65.95 166.1 63.56 167.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "67.25 169.61 64.84 168.22 67.23 166.84 69.64 168.23 67.25 169.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "41.49 158.95 39.08 157.56 41.47 156.18 43.88 157.56 41.49 158.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "45.17 161.07 42.77 159.69 45.16 158.3 47.57 159.69 45.17 161.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "48.86 163.2 46.45 161.81 48.85 160.43 51.25 161.82 48.86 163.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "52.55 165.33 50.14 163.94 52.53 162.56 54.94 163.95 52.55 165.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "56.23 167.46 53.83 166.07 56.22 164.69 58.63 166.08 56.23 167.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "59.92 169.59 57.51 168.2 59.91 166.82 62.31 168.21 59.92 169.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "63.61 171.72 61.2 170.33 63.59 168.95 66 170.34 63.61 171.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "37.85 161.05 35.44 159.66 37.83 158.28 40.24 159.67 37.85 161.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "41.53 163.18 39.13 161.79 41.52 160.41 43.93 161.8 41.53 163.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "45.22 165.31 42.81 163.91 45.2 162.53 47.61 163.92 45.22 165.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "48.91 167.43 46.5 166.04 48.89 164.66 51.3 166.05 48.91 167.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "52.59 169.56 50.19 168.17 52.58 166.79 54.98 168.18 52.59 169.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "56.28 171.69 53.87 170.3 56.27 168.92 58.67 170.31 56.28 171.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "59.97 173.82 57.56 172.43 59.95 171.05 62.36 172.44 59.97 173.82"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "269.74 298.99 267.33 297.6 269.72 296.22 272.13 297.61 269.74 298.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "273.42 301.12 271.01 299.73 273.41 298.35 275.81 299.74 273.42 301.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "277.11 303.25 274.7 301.86 277.09 300.48 279.5 301.87 277.11 303.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "280.8 305.38 278.39 303.99 280.78 302.6 283.19 303.99 280.8 305.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "284.48 307.5 282.07 306.11 284.47 304.73 286.87 306.12 284.48 307.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "288.17 309.63 285.76 308.24 288.15 306.86 290.56 308.25 288.17 309.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "291.86 311.76 289.45 310.37 291.84 308.99 294.25 310.38 291.86 311.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "266.1 301.09 263.69 299.7 266.08 298.32 268.49 299.71 266.1 301.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "269.78 303.22 267.37 301.83 269.77 300.45 272.17 301.84 269.78 303.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "273.47 305.35 271.06 303.96 273.45 302.58 275.86 303.97 273.47 305.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "277.15 307.48 274.75 306.09 277.14 304.71 279.55 306.1 277.15 307.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "280.84 309.61 278.43 308.22 280.83 306.83 283.23 308.22 280.84 309.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "284.53 311.73 282.12 310.34 284.51 308.96 286.92 310.35 284.53 311.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "288.21 313.86 285.81 312.47 288.2 311.09 290.61 312.48 288.21 313.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "262.45 303.19 260.05 301.8 262.44 300.42 264.85 301.81 262.45 303.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "266.14 305.32 263.73 303.93 266.13 302.55 268.53 303.94 266.14 305.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "269.83 307.45 267.42 306.06 269.81 304.68 272.22 306.07 269.83 307.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "273.51 309.58 271.11 308.19 273.5 306.81 275.9 308.2 273.51 309.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "277.2 311.71 274.79 310.32 277.19 308.94 279.59 310.33 277.2 311.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "280.89 313.84 278.48 312.45 280.87 311.06 283.28 312.45 280.89 313.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "284.57 315.96 282.17 314.57 284.56 313.19 286.96 314.58 284.57 315.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "258.81 305.3 256.41 303.91 258.8 302.52 261.2 303.92 258.81 305.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "262.5 307.42 260.09 306.04 262.48 304.65 264.89 306.04 262.5 307.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "266.19 309.55 263.78 308.16 266.17 306.78 268.58 308.17 266.19 309.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "269.87 311.68 267.46 310.29 269.86 308.91 272.26 310.3 269.87 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "273.56 313.81 271.15 312.42 273.54 311.04 275.95 312.43 273.56 313.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "277.25 315.94 274.84 314.55 277.23 313.17 279.64 314.56 277.25 315.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "280.93 318.07 278.52 316.68 280.92 315.3 283.32 316.69 280.93 318.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "255.17 307.4 252.76 306.01 255.16 304.63 257.56 306.02 255.17 307.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "258.86 309.53 256.45 308.14 258.84 306.76 261.25 308.14 258.86 309.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "266.23 313.78 263.82 312.39 266.22 311.01 268.62 312.4 266.23 313.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "269.92 315.91 267.51 314.52 269.9 313.14 272.31 314.53 269.92 315.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "273.6 318.04 271.2 316.65 273.59 315.27 276 316.66 273.6 318.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "277.29 320.17 274.88 318.78 277.28 317.4 279.68 318.79 277.29 320.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "251.53 309.5 249.12 308.11 251.52 306.73 253.92 308.12 251.53 309.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "255.22 311.63 252.81 310.24 255.2 308.86 257.61 310.25 255.22 311.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "262.59 315.88 260.18 314.5 262.57 313.12 264.98 314.5 262.59 315.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "269.96 320.14 267.56 318.75 269.95 317.37 272.36 318.76 269.96 320.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "273.65 322.27 271.24 320.88 273.63 319.5 276.04 320.89 273.65 322.27"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "251.58 313.73 249.17 312.34 251.56 310.96 253.97 312.35 251.58 313.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "258.95 317.99 256.54 316.6 258.93 315.22 261.34 316.61 258.95 317.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "266.32 322.24 263.92 320.86 266.31 319.47 268.71 320.86 266.32 322.24"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "184.99 271.49 182.58 270.1 184.97 268.72 187.38 270.11 184.99 271.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "188.67 273.62 186.26 272.23 188.66 270.85 191.06 272.24 188.67 273.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "192.36 275.75 189.95 274.36 192.34 272.98 194.75 274.37 192.36 275.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "196.04 277.88 193.64 276.49 196.03 275.1 198.44 276.49 196.04 277.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "199.73 280 197.32 278.61 199.72 277.23 202.12 278.62 199.73 280"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.42 282.13 201.01 280.74 203.4 279.36 205.81 280.75 203.42 282.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "207.1 284.26 204.7 282.87 207.09 281.49 209.5 282.88 207.1 284.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "181.34 273.59 178.94 272.2 181.33 270.82 183.74 272.21 181.34 273.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "185.03 275.72 182.62 274.33 185.02 272.95 187.42 274.34 185.03 275.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "188.72 277.85 186.31 276.46 188.7 275.08 191.11 276.47 188.72 277.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "192.4 279.98 190 278.59 192.39 277.21 194.8 278.6 192.4 279.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "196.09 282.11 193.68 280.72 196.08 279.33 198.48 280.72 196.09 282.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "199.78 284.23 197.37 282.84 199.76 281.46 202.17 282.85 199.78 284.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "203.46 286.36 201.06 284.97 203.45 283.59 205.86 284.98 203.46 286.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "177.7 275.69 175.3 274.3 177.69 272.92 180.1 274.31 177.7 275.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "181.39 277.82 178.98 276.43 181.38 275.05 183.78 276.44 181.39 277.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "185.08 279.95 182.67 278.56 185.06 277.18 187.47 278.57 185.08 279.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "188.76 282.08 186.36 280.69 188.75 279.31 191.16 280.7 188.76 282.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "192.45 284.21 190.04 282.82 192.44 281.44 194.84 282.83 192.45 284.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "196.14 286.34 193.73 284.95 196.12 283.56 198.53 284.95 196.14 286.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "199.82 288.46 197.42 287.07 199.81 285.69 202.22 287.08 199.82 288.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "174.06 277.8 171.66 276.41 174.05 275.02 176.46 276.42 174.06 277.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "177.75 279.92 175.34 278.54 177.73 277.15 180.14 278.54 177.75 279.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "181.44 282.05 179.03 280.66 181.42 279.28 183.83 280.67 181.44 282.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "185.12 284.18 182.72 282.79 185.11 281.41 187.51 282.8 185.12 284.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "188.81 286.31 186.4 284.92 188.79 283.54 191.2 284.93 188.81 286.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "192.5 288.44 190.09 287.05 192.48 285.67 194.89 287.06 192.5 288.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "196.18 290.57 193.78 289.18 196.17 287.8 198.57 289.19 196.18 290.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "170.42 279.9 168.01 278.51 170.41 277.13 172.81 278.52 170.42 279.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "174.11 282.03 171.7 280.64 174.09 279.26 176.5 280.64 174.11 282.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "181.48 286.28 179.07 284.89 181.47 283.51 183.87 284.9 181.48 286.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "185.17 288.41 182.76 287.02 185.15 285.64 187.56 287.03 185.17 288.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "188.85 290.54 186.45 289.15 188.84 287.77 191.25 289.16 188.85 290.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "192.54 292.67 190.13 291.28 192.53 289.9 194.93 291.29 192.54 292.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "166.78 282 164.37 280.61 166.77 279.23 169.17 280.62 166.78 282"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "170.47 284.13 168.06 282.74 170.45 281.36 172.86 282.75 170.47 284.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "177.84 288.38 175.43 287 177.82 285.62 180.23 287 177.84 288.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "185.21 292.64 182.81 291.25 185.2 289.87 187.6 291.26 185.21 292.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "188.9 294.77 186.49 293.38 188.88 292 191.29 293.39 188.9 294.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "166.83 286.23 164.42 284.84 166.81 283.46 169.22 284.85 166.83 286.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "174.2 290.49 171.79 289.1 174.18 287.72 176.59 289.11 174.2 290.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "181.57 294.74 179.16 293.36 181.56 291.97 183.96 293.36 181.57 294.74"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "78.99 247.99 76.58 246.6 78.97 245.22 81.38 246.61 78.99 247.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.67 250.12 80.27 248.73 82.66 247.35 85.06 248.74 82.67 250.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "86.36 252.25 83.95 250.86 86.34 249.48 88.75 250.87 86.36 252.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "90.05 254.38 87.64 252.99 90.03 251.6 92.44 252.99 90.05 254.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "93.73 256.5 91.33 255.11 93.72 253.73 96.12 255.12 93.73 256.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "97.42 258.63 95.01 257.24 97.4 255.86 99.81 257.25 97.42 258.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "101.11 260.76 98.7 259.37 101.09 257.99 103.5 259.38 101.11 260.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "75.34 250.09 72.94 248.7 75.33 247.32 77.74 248.71 75.34 250.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "79.03 252.22 76.62 250.83 79.02 249.45 81.42 250.84 79.03 252.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.72 254.35 80.31 252.96 82.7 251.58 85.11 252.97 82.72 254.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "86.4 256.48 84 255.09 86.39 253.71 88.8 255.1 86.4 256.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "90.09 258.61 87.68 257.22 90.08 255.84 92.48 257.22 90.09 258.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "93.78 260.73 91.37 259.34 93.76 257.96 96.17 259.35 93.78 260.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "97.46 262.86 95.06 261.47 97.45 260.09 99.86 261.48 97.46 262.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "71.7 252.19 69.3 250.8 71.69 249.42 74.1 250.81 71.7 252.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "75.39 254.32 72.98 252.93 75.38 251.55 77.78 252.94 75.39 254.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "79.08 256.45 76.67 255.06 79.06 253.68 81.47 255.07 79.08 256.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.76 258.58 80.36 257.19 82.75 255.81 85.16 257.2 82.76 258.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "86.45 260.71 84.04 259.32 86.44 257.94 88.84 259.33 86.45 260.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "90.14 262.84 87.73 261.45 90.12 260.06 92.53 261.45 90.14 262.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "93.82 264.96 91.42 263.57 93.81 262.19 96.22 263.58 93.82 264.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "68.06 254.3 65.66 252.91 68.05 251.53 70.45 252.91 68.06 254.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "71.75 256.42 69.34 255.03 71.73 253.65 74.14 255.04 71.75 256.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "75.44 258.55 73.03 257.16 75.42 255.78 77.83 257.17 75.44 258.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "79.12 260.68 76.72 259.29 79.11 257.91 81.51 259.3 79.12 260.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "82.81 262.81 80.4 261.42 82.79 260.04 85.2 261.43 82.81 262.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "86.5 264.94 84.09 263.55 86.48 262.17 88.89 263.56 86.5 264.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "90.18 267.07 87.78 265.68 90.17 264.3 92.57 265.69 90.18 267.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "64.42 256.4 62.02 255.01 64.41 253.63 66.81 255.02 64.42 256.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "68.11 258.53 65.7 257.14 68.09 255.76 70.5 257.14 68.11 258.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "75.48 262.78 73.07 261.39 75.47 260.01 77.87 261.4 75.48 262.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "79.17 264.91 76.76 263.52 79.15 262.14 81.56 263.53 79.17 264.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "82.85 267.04 80.45 265.65 82.84 264.27 85.25 265.66 82.85 267.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "86.54 269.17 84.13 267.78 86.53 266.4 88.93 267.79 86.54 269.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "60.78 258.5 58.37 257.11 60.77 255.73 63.17 257.12 60.78 258.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "64.47 260.63 62.06 259.24 64.45 257.86 66.86 259.25 64.47 260.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "71.84 264.88 69.43 263.5 71.83 262.12 74.23 263.5 71.84 264.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "79.21 269.14 76.81 267.75 79.2 266.37 81.61 267.76 79.21 269.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "82.9 271.27 80.49 269.88 82.89 268.5 85.29 269.89 82.9 271.27"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "60.83 262.73 58.42 261.34 60.81 259.96 63.22 261.35 60.83 262.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "68.2 266.99 65.79 265.6 68.18 264.22 70.59 265.61 68.2 266.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "75.57 271.24 73.17 269.86 75.56 268.47 77.96 269.86 75.57 271.24"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "78.55 205.55 76.14 204.16 78.53 202.78 80.94 204.17 78.55 205.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.23 207.68 79.83 206.29 82.22 204.91 84.63 206.3 82.23 207.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "85.92 209.81 83.51 208.42 85.91 207.04 88.31 208.43 85.92 209.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "89.61 211.94 87.2 210.55 89.59 209.17 92 210.56 89.61 211.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "93.29 214.07 90.89 212.68 93.28 211.29 95.69 212.69 93.29 214.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "96.98 216.19 94.57 214.8 96.97 213.42 99.37 214.81 96.98 216.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "100.67 218.32 98.26 216.93 100.65 215.55 103.06 216.94 100.67 218.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "74.91 207.65 72.5 206.26 74.89 204.88 77.3 206.27 74.91 207.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "78.59 209.78 76.19 208.39 78.58 207.01 80.99 208.4 78.59 209.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.28 211.91 79.87 210.52 82.27 209.14 84.67 210.53 82.28 211.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "85.97 214.04 83.56 212.65 85.95 211.27 88.36 212.66 85.97 214.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "89.65 216.17 87.25 214.78 89.64 213.4 92.05 214.79 89.65 216.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "93.34 218.3 90.93 216.91 93.33 215.53 95.73 216.91 93.34 218.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "97.03 220.43 94.62 219.03 97.01 217.65 99.42 219.04 97.03 220.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "71.27 209.76 68.86 208.37 71.25 206.99 73.66 208.38 71.27 209.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "74.95 211.88 72.55 210.5 74.94 209.11 77.34 210.5 74.95 211.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "78.64 214.01 76.23 212.62 78.62 211.24 81.03 212.63 78.64 214.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.33 216.14 79.92 214.75 82.31 213.37 84.72 214.76 82.33 216.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "86.01 218.27 83.61 216.88 86 215.5 88.4 216.89 86.01 218.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "89.7 220.4 87.29 219.01 89.68 217.63 92.09 219.02 89.7 220.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "93.39 222.53 90.98 221.14 93.37 219.76 95.78 221.15 93.39 222.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "67.63 211.86 65.22 210.47 67.61 209.09 70.02 210.48 67.63 211.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "71.31 213.99 68.91 212.6 71.3 211.22 73.7 212.61 71.31 213.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "75 216.12 72.59 214.73 74.98 213.34 77.39 214.73 75 216.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "78.69 218.24 76.28 216.85 78.67 215.47 81.08 216.86 78.69 218.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "82.37 220.37 79.96 218.98 82.36 217.6 84.76 218.99 82.37 220.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "86.06 222.5 83.65 221.11 86.04 219.73 88.45 221.12 86.06 222.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "89.74 224.63 87.34 223.24 89.73 221.86 92.14 223.25 89.74 224.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "63.98 213.96 61.58 212.57 63.97 211.19 66.38 212.58 63.98 213.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "67.67 216.09 65.26 214.7 67.66 213.32 70.06 214.71 67.67 216.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "75.04 220.35 72.64 218.96 75.03 217.57 77.44 218.97 75.04 220.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "78.73 222.47 76.32 221.08 78.72 219.7 81.12 221.09 78.73 222.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "82.42 224.6 80.01 223.21 82.4 221.83 84.81 223.22 82.42 224.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "86.1 226.73 83.7 225.34 86.09 223.96 88.5 225.35 86.1 226.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "60.34 216.06 57.94 214.67 60.33 213.29 62.73 214.68 60.34 216.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "64.03 218.19 61.62 216.8 64.02 215.42 66.42 216.81 64.03 218.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "71.4 222.45 69 221.06 71.39 219.68 73.8 221.07 71.4 222.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "78.78 226.71 76.37 225.31 78.76 223.93 81.17 225.32 78.78 226.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "82.46 228.83 80.06 227.44 82.45 226.06 84.85 227.45 82.46 228.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "60.39 220.29 57.98 218.9 60.37 217.52 62.78 218.91 60.39 220.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "67.76 224.55 65.36 223.16 67.75 221.78 70.15 223.17 67.76 224.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "75.14 228.81 72.73 227.42 75.12 226.04 77.53 227.43 75.14 228.81"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "34.3 163.24 31.89 161.85 34.28 160.47 36.69 161.86 34.3 163.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "37.98 165.37 35.58 163.98 37.97 162.6 40.38 163.99 37.98 165.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "41.67 167.5 39.26 166.11 41.66 164.73 44.06 166.12 41.67 167.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "45.36 169.63 42.95 168.24 45.34 166.85 47.75 168.24 45.36 169.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "49.04 171.75 46.64 170.36 49.03 168.98 51.44 170.37 49.04 171.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "52.73 173.88 50.32 172.49 52.72 171.11 55.12 172.5 52.73 173.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "56.42 176.01 54.01 174.62 56.4 173.24 58.81 174.63 56.42 176.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "30.66 165.34 28.25 163.95 30.64 162.57 33.05 163.96 30.66 165.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "34.34 167.47 31.94 166.08 34.33 164.7 36.74 166.09 34.34 167.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "38.03 169.6 35.62 168.21 38.02 166.83 40.42 168.22 38.03 169.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "41.72 171.73 39.31 170.34 41.7 168.96 44.11 170.35 41.72 171.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "45.4 173.85 43 172.47 45.39 171.09 47.8 172.47 45.4 173.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "49.09 175.98 46.68 174.59 49.08 173.21 51.48 174.6 49.09 175.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "52.78 178.11 50.37 176.72 52.76 175.34 55.17 176.73 52.78 178.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "27.02 167.44 24.61 166.05 27 164.67 29.41 166.06 27.02 167.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "30.7 169.57 28.3 168.18 30.69 166.8 33.09 168.19 30.7 169.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "34.39 171.7 31.98 170.31 34.37 168.93 36.78 170.32 34.39 171.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "38.08 173.83 35.67 172.44 38.06 171.06 40.47 172.45 38.08 173.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "41.76 175.96 39.35 174.57 41.75 173.19 44.15 174.58 41.76 175.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "45.45 178.09 43.04 176.7 45.43 175.31 47.84 176.71 45.45 178.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "49.13 180.21 46.73 178.82 49.12 177.44 51.53 178.83 49.13 180.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "23.38 169.55 20.97 168.16 23.36 166.78 25.77 168.16 23.38 169.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "27.06 171.67 24.66 170.28 27.05 168.9 29.45 170.29 27.06 171.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "30.75 173.8 28.34 172.41 30.73 171.03 33.14 172.42 30.75 173.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "34.44 175.93 32.03 174.54 34.42 173.16 36.83 174.55 34.44 175.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "38.12 178.06 35.71 176.67 38.11 175.29 40.51 176.68 38.12 178.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "41.81 180.19 39.4 178.8 41.79 177.42 44.2 178.81 41.81 180.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "45.49 182.32 43.09 180.93 45.48 179.55 47.89 180.94 45.49 182.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "19.73 171.65 17.33 170.26 19.72 168.88 22.13 170.27 19.73 171.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "23.42 173.78 21.01 172.39 23.41 171.01 25.81 172.4 23.42 173.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "30.79 178.03 28.39 176.64 30.78 175.26 33.19 176.65 30.79 178.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "34.48 180.16 32.07 178.77 34.47 177.39 36.87 178.78 34.48 180.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "38.17 182.29 35.76 180.9 38.15 179.52 40.56 180.91 38.17 182.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "41.85 184.42 39.45 183.03 41.84 181.65 44.24 183.04 41.85 184.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "16.09 173.75 13.69 172.36 16.08 170.98 18.48 172.37 16.09 173.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "19.78 175.88 17.37 174.49 19.77 173.11 22.17 174.5 19.78 175.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "27.15 180.13 24.75 178.75 27.14 177.37 29.55 178.75 27.15 180.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "34.53 184.39 32.12 183 34.51 181.62 36.92 183.01 34.53 184.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "38.21 186.52 35.8 185.13 38.2 183.75 40.6 185.14 38.21 186.52"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "16.14 177.98 13.73 176.59 16.12 175.21 18.53 176.6 16.14 177.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "23.51 182.24 21.11 180.85 23.5 179.47 25.9 180.86 23.51 182.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "30.89 186.49 28.48 185.1 30.87 183.72 33.28 185.11 30.89 186.49"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M395.16,246.15c0-8.83-6.23-19.58-13.92-24-3.57-2.06-6.83-2.39-9.29-1.28-.42.23-.82.47-1.22.72-2.12,1.58-3.41,4.49-3.41,8.5,0,8.82,6.23,19.57,13.92,24,3.57,2.06,6.83,2.4,9.29,1.29.42-.23.82-.47,1.22-.72C393.87,253.07,395.16,250.15,395.16,246.15Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M395.16,246.15c0-8.83-6.23-19.58-13.92-24-3.57-2.06-6.83-2.39-9.29-1.28-.42.23-.82.47-1.22.72-2.12,1.58-3.41,4.49-3.41,8.5,0,8.82,6.23,19.57,13.92,24,3.57,2.06,6.83,2.4,9.29,1.29.42-.23.82-.47,1.22-.72C393.87,253.07,395.16,250.15,395.16,246.15Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M395.16,246.15c0-8.83-6.23-19.58-13.92-24-3.57-2.06-6.83-2.39-9.29-1.28-.42.23-.82.47-1.22.72-2.12,1.58-3.41,4.49-3.41,8.5,0,8.82,6.23,19.57,13.92,24,3.57,2.06,6.83,2.4,9.29,1.29.42-.23.82-.47,1.22-.72C393.87,253.07,395.16,250.15,395.16,246.15Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 103.88,
    cy: 177.19,
    r: 16.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M381.24,222.13c7.69,4.44,13.92,15.19,13.92,24,0,4-1.29,6.92-3.41,8.5a19.6,19.6,0,0,0-19.8-33.8C374.41,219.74,377.67,220.07,381.24,222.13Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-178",
    cx: 104.67,
    cy: 176.92,
    r: 19.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M376.92,224.29c-3.57-2.06-6.83-2.39-9.29-1.28-.42.23-.82.47-1.22.72a19.6,19.6,0,0,0,19.8,33.8c.42-.23.82-.47,1.22-.72,2.12-1.58,3.41-4.5,3.41-8.5C390.84,239.48,384.61,228.73,376.92,224.29Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-180",
    cx: 95.4,
    cy: 175.73,
    r: 12.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-181",
    cx: 365.79,
    cy: 246.64,
    rx: 6.54,
    ry: 11.33,
    transform: "translate(-350.12 156.24) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M373.56,251.16c0,5-3.51,7-7.83,4.46s-7.82-8.54-7.82-13.49,3.5-7,7.82-4.46S373.56,246.2,373.56,251.16Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-183",
    cx: 365.68,
    cy: 246.65,
    rx: 6.19,
    ry: 10.73,
    transform: "translate(-350.14 156.19) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M373,250.93c0,4.69-3.31,6.58-7.4,4.22a16.31,16.31,0,0,1-7.4-12.77c0-4.69,3.31-6.57,7.4-4.21A16.28,16.28,0,0,1,373,250.93Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-185",
    cx: 365.58,
    cy: 246.66,
    rx: 5.85,
    ry: 10.13,
    transform: "translate(-350.16 156.15) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M372.51,250.7c0,4.42-3.13,6.2-7,4a15.41,15.41,0,0,1-7-12c0-4.42,3.13-6.2,7-4A15.41,15.41,0,0,1,372.51,250.7Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-187",
    cx: 365.48,
    cy: 246.68,
    rx: 5.51,
    ry: 9.54,
    transform: "translate(-350.19 156.1) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-188",
    cx: 365.43,
    cy: 246.68,
    rx: 5.34,
    ry: 9.24,
    transform: "translate(-350.2 156.07) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M371.72,250.35c0,4-2.84,5.64-6.34,3.62A14,14,0,0,1,359,243c0-4,2.84-5.64,6.35-3.62A14,14,0,0,1,371.72,250.35Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-190",
    cx: 365.32,
    cy: 246.7,
    rx: 4.99,
    ry: 8.65,
    transform: "translate(-350.22 156.02) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M371.2,250.12c0,3.76-2.66,5.27-5.93,3.38a13,13,0,0,1-5.92-10.21c0-3.76,2.65-5.27,5.92-3.38A13.06,13.06,0,0,1,371.2,250.12Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M370.93,250c0,3.62-2.55,5.08-5.71,3.25a12.59,12.59,0,0,1-5.71-9.85c0-3.62,2.56-5.07,5.71-3.25A12.56,12.56,0,0,1,370.93,250Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M370.93,250c0,3.62-2.55,5.08-5.71,3.25a12.59,12.59,0,0,1-5.71-9.85c0-3.62,2.56-5.07,5.71-3.25A12.56,12.56,0,0,1,370.93,250Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M366.43,247.55c0,.75-.53,1.06-1.19.68a2.62,2.62,0,0,1-1.19-2c0-.76.53-1.06,1.19-.68A2.62,2.62,0,0,1,366.43,247.55Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-194",
    cx: 89.59,
    cy: 184.79,
    r: 4.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M365.78,237a7.73,7.73,0,0,0-3.87-1.18,4.63,4.63,0,0,0-4.56,3.63c0,.27,0,.54,0,.82a19.61,19.61,0,0,0,10.1,17.14,6.55,6.55,0,0,0,1.87.29c3,0,4.91-2.43,4.91-6.19C374.2,246.18,370.42,239.67,365.78,237ZM369.29,257a7.09,7.09,0,0,1-3.51-1.08c-4.43-2.56-8-8.78-8-13.86,0-3.36,1.59-5.44,4.16-5.44a7.06,7.06,0,0,1,3.5,1.08c4.43,2.55,8,8.77,8,13.86C373.45,254.86,371.85,257,369.29,257Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M396.37,225.65l-.68-.78a47.77,47.77,0,0,0-9.45,1.23c.21.22.42.43.62.65A47.09,47.09,0,0,1,396.37,225.65Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M400.8,237a47.39,47.39,0,0,1-5.87,6.24c.05.31.09.61.12.92a48,48,0,0,0,5.78-5.93s0-.07,0-.11C400.84,237.73,400.82,237.36,400.8,237Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M368.38,239c4.62-6.14,12.29-10.19,13.46-10.79-.19-.19-.37-.38-.56-.56-1.77.91-9,4.85-13.48,10.83Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M359.93,230.5c-.31.55-.6,1.12-.87,1.7a30,30,0,0,0,.21,4.43,4.88,4.88,0,0,1,.74-.42A32.1,32.1,0,0,1,359.93,230.5Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M371.71,257a4.2,4.2,0,0,1-.77.37c.61.46,1.8,1.31,3.4,2.29.59.07,1.18.12,1.79.14A47.15,47.15,0,0,1,371.71,257Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M390.69,246c-.45.22-8.61,4.11-16.6,4,0,.26.06.52.08.77h.25c7.45,0,14.82-3.29,16.35-4C390.75,246.53,390.72,246.26,390.69,246Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "103.85 190.84 101.45 189.45 103.84 188.07 106.25 189.46 103.85 190.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "107.54 192.97 105.13 191.58 107.53 190.2 109.93 191.59 107.54 192.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.23 195.1 108.82 193.71 111.21 192.33 113.62 193.72 111.23 195.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.21 192.95 97.81 191.56 100.2 190.18 102.61 191.56 100.21 192.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "103.9 195.07 101.49 193.69 103.88 192.3 106.29 193.69 103.9 195.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "107.59 197.2 105.18 195.81 107.57 194.43 109.98 195.82 107.59 197.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "111.14 186.63 108.73 185.24 111.12 183.85 113.53 185.24 111.14 186.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "114.82 188.75 112.42 187.36 114.81 185.98 117.21 187.37 114.82 188.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "118.51 190.88 116.1 189.49 118.49 188.11 120.9 189.5 118.51 190.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "107.49 188.73 105.09 187.34 107.48 185.96 109.89 187.35 107.49 188.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.18 190.86 108.77 189.47 111.17 188.09 113.57 189.47 111.18 190.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "114.87 192.98 112.46 191.59 114.85 190.21 117.26 191.6 114.87 192.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "96.57 195.05 94.17 193.66 96.56 192.28 98.96 193.67 96.57 195.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.26 197.18 97.85 195.79 100.24 194.41 102.65 195.8 100.26 197.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "103.94 199.31 101.54 197.91 103.93 196.53 106.34 197.92 103.94 199.31"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M398.5,301.68H362.84v3h0s0,.1,0,.14c0,5.74,8,10.39,17.83,10.39s17.83-4.65,17.83-10.39c0,0,0-.09,0-.14h0Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M399.08,299.58H362.26v3.13h0v.15c0,5.92,8.24,10.72,18.41,10.72s18.41-4.8,18.41-10.72a.76.76,0,0,0,0-.15h0Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-201",
    cx: 105.02,
    cy: 237.57,
    rx: 18.41,
    ry: 10.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-202",
    cx: 105.02,
    cy: 237.12,
    rx: 16.62,
    ry: 9.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M398.18,290.24h-35v8.92h0s0,.09,0,.14c0,5.63,7.85,10.19,17.52,10.19s17.51-4.56,17.51-10.19v-.14h0Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-204",
    cx: 93.68,
    cy: 239.36,
    r: 4.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M369.08,303.06c0,.75-.53,1.05-1.19.67a2.6,2.6,0,0,1-1.18-2.05c0-.75.53-1.05,1.18-.67A2.59,2.59,0,0,1,369.08,303.06Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-205",
    cx: 92.24,
    cy: 240.29,
    r: 4.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M399.08,290.9h0v-.07h0a18.41,18.41,0,0,0-36.82,0h0v.07h0V294h0v.15c0,5.92,8.24,10.72,18.41,10.72s18.41-4.8,18.41-10.72a.76.76,0,0,0,0-.15h0Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M378.28,291.62c4-8.19,7.49-16.33,2.49-18.08s-15.08,5.58-17,12.87c-1.59,6.09-1.24,7.49-1.24,7.54-.14,6.14,4.05,11.22,9.35,11.33S374.32,299.82,378.28,291.62Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "104.52 246.01 102.11 244.62 104.5 243.24 106.91 244.63 104.52 246.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "108.21 248.14 105.8 246.75 108.19 245.37 110.6 246.76 108.21 248.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.89 250.27 109.49 248.88 111.88 247.5 114.28 248.89 111.89 250.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.88 248.11 98.47 246.72 100.86 245.34 103.27 246.73 100.88 248.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "104.57 250.24 102.16 248.85 104.55 247.47 106.96 248.86 104.57 250.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "108.25 252.37 105.84 250.98 108.24 249.6 110.64 250.99 108.25 252.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "111.8 241.79 109.39 240.4 111.79 239.02 114.19 240.41 111.8 241.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "115.49 243.92 113.08 242.53 115.47 241.15 117.88 242.54 115.49 243.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "119.17 246.05 116.77 244.66 119.16 243.28 121.57 244.67 119.17 246.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "108.16 243.89 105.75 242.5 108.15 241.12 110.55 242.51 108.16 243.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "111.85 246.02 109.44 244.63 111.83 243.25 114.24 244.64 111.85 246.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "115.53 248.15 113.13 246.76 115.52 245.38 117.93 246.77 115.53 248.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "97.24 250.22 94.83 248.82 97.22 247.44 99.63 248.83 97.24 250.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "100.92 252.34 98.52 250.95 100.91 249.57 103.32 250.96 100.92 252.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "104.61 254.47 102.2 253.08 104.6 251.7 107 253.09 104.61 254.47"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M520.23,330.77c11.47,9,28.27,15.43,47.66,17.87v-49c-19.39-2.44-36.19-8.93-47.66-17.87Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M568.39,349.21l-.56-.07c-19.12-2.41-36.14-8.79-47.91-18l-.19-.16v-50.3l.81.63c11.63,9.08,28.47,15.39,47.42,17.77l.43.06Zm-47.66-18.68c11.51,8.9,28,15.12,46.66,17.54v-48c-18.51-2.39-35-8.52-46.66-17.3Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M504.2,253.27v.33c0-.11,0-.22,0-.33Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M542.11,332.9A84.63,84.63,0,0,1,525,324.44v1.77a87.62,87.62,0,0,0,17.07,8.3Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M542.11,338v-1.61A84.63,84.63,0,0,1,525,328v1.78A87.89,87.89,0,0,0,542.11,338Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M545.19,330.47v1.59A119,119,0,0,0,563,336.41v-1.56A115.76,115.76,0,0,1,545.19,330.47Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M545.19,327v1.59A117.81,117.81,0,0,0,563,332.89v-1.55A118.11,118.11,0,0,1,545.19,327Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M545.19,323.44V325A119,119,0,0,0,563,329.38v-1.55A116.92,116.92,0,0,1,545.19,323.44Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M545.19,334v1.59A119,119,0,0,0,563,339.92v-1.56A115.76,115.76,0,0,1,545.19,334Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M563,341.88a116.92,116.92,0,0,1-17.84-4.39v1.6A119,119,0,0,0,563,343.44Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M542.11,329.38A84.63,84.63,0,0,1,525,320.92v1.78A87,87,0,0,0,542.11,331Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M525,317.41v1.78a87.61,87.61,0,0,0,17.07,8.29v-1.61A84.63,84.63,0,0,1,525,317.41Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M525,313.9v1.78A87.61,87.61,0,0,0,542.11,324v-1.61A84.63,84.63,0,0,1,525,313.9Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M525,310.39v1.77a87.62,87.62,0,0,0,17.07,8.3v-1.61A84.63,84.63,0,0,1,525,310.39Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M525,296.34v1.78a87.61,87.61,0,0,0,17.07,8.29V304.8A84.63,84.63,0,0,1,525,296.34Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M525,299.85v1.78a87.61,87.61,0,0,0,17.07,8.29v-1.61A84.63,84.63,0,0,1,525,299.85Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M525,303.36v1.78a87,87,0,0,0,17.07,8.29v-1.61A84.11,84.11,0,0,1,525,303.36Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M525,306.88v1.77a87.62,87.62,0,0,0,17.07,8.3v-1.61A84.63,84.63,0,0,1,525,306.88Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M545.19,319.93v1.6A119,119,0,0,0,563,325.87v-1.55A116.92,116.92,0,0,1,545.19,319.93Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M545.19,305.88v1.6A117.81,117.81,0,0,0,563,311.82v-1.55A116.92,116.92,0,0,1,545.19,305.88Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M545.19,309.4V311A117.81,117.81,0,0,0,563,315.33v-1.55A118.11,118.11,0,0,1,545.19,309.4Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M545.19,302.37V304A119,119,0,0,0,563,308.31v-1.55A116.92,116.92,0,0,1,545.19,302.37Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M545.19,316.42V318A119,119,0,0,0,563,322.36V320.8A115.76,115.76,0,0,1,545.19,316.42Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M545.19,312.91v1.59A119,119,0,0,0,563,318.85v-1.56A115.76,115.76,0,0,1,545.19,312.91Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M525,291.09a87.62,87.62,0,0,0,17.07,8.3v-1.6A84.63,84.63,0,0,1,525,289.33Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M545.19,298.87v1.58A117.81,117.81,0,0,0,563,304.8v-1.55A115.76,115.76,0,0,1,545.19,298.87Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M542.11,302.9v-1.61A84.63,84.63,0,0,1,525,292.83v1.77A87.62,87.62,0,0,0,542.11,302.9Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M329.55,324.88c11.47,8.95,28.28,15.43,47.67,17.87v-36.1c-19.39-2.45-36.2-8.93-47.67-17.88Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.72,343.32l-.56-.07c-19.13-2.41-36.15-8.79-47.92-18l-.19-.15V287.75l.81.63c11.63,9.07,28.47,15.38,47.42,17.77l.44.05Zm-47.67-18.69c11.51,8.91,28.05,15.13,46.67,17.55V307.09c-18.52-2.4-35-8.52-46.67-17.3Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M313.53,247.38v.33c0-.11,0-.22,0-.33Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M353.14,317.11v1.6c.88.29,1.79.55,2.69.83V318C354.93,317.68,354,317.41,353.14,317.11Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M351.43,318.08v-1.61a93.12,93.12,0,0,1-9.79-4.27v1.68A94.8,94.8,0,0,0,351.43,318.08Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M351.43,311.06v-1.62c-1.61-.59-3.19-1.22-4.72-1.88v1.63C348.24,309.84,349.82,310.47,351.43,311.06Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M338.11,299.77q-1.94-1.11-3.75-2.3v1.78c1.21.77,2.46,1.51,3.75,2.24Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M345.14,306.86A79.77,79.77,0,0,1,334.36,301v1.77a83.74,83.74,0,0,0,10.78,5.75Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M339.68,302.33a90.22,90.22,0,0,0,11.75,5.21v-1.61a89.22,89.22,0,0,1-11.75-5.3Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M353.14,320.6h0c-1.6-.59-3.26-1.25-4.93-2v1.63c1.67.7,3.34,1.36,4.93,1.94,2.09.69,4.25,1.3,6.44,1.89v-1.58C357.38,321.92,355.22,321.3,353.14,320.6Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M353.14,327.54v0c-2.89-1.06-6-2.36-9-3.77v1.67c3,1.38,6.12,2.66,9,3.71,1.13.38,2.28.72,3.44,1.06v-1.58C355.42,328.27,354.27,327.92,353.14,327.54Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M360.58,312.27c-2.55-.66-5-1.38-7.44-2.18v1.59c2.4.8,4.9,1.51,7.44,2.16Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M351.43,325.1v-1.61a89.67,89.67,0,0,1-12.22-5.55v1.7A92.45,92.45,0,0,0,351.43,325.1Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M348.52,311.76v1.63c1.57.65,3.13,1.26,4.62,1.81,3.45,1.14,7.08,2.11,10.82,2.95v-1.56c-3.75-.85-7.37-1.84-10.82-3h0C351.64,313,350.09,312.42,348.52,311.76Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M357.18,307.84c-1.37-.4-2.72-.82-4-1.26v1.59c1.32.44,2.67.85,4,1.25Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M353.14,324.14v1.59a116.44,116.44,0,0,0,12.69,3.38v-1.56A115.23,115.23,0,0,1,353.14,324.14Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M347,311.09a89.7,89.7,0,0,1-12.6-6.59v1.77a93.27,93.27,0,0,0,12.6,6.46Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M358.74,308.26v1.58A121.8,121.8,0,0,0,371,312.52V311A119.08,119.08,0,0,1,358.74,308.26Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M357.39,320a119,119,0,0,0,13.59,3V321.5a121.11,121.11,0,0,1-13.59-3.06Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M361.14,324.5c3.19.79,6.46,1.48,9.84,2V325c-3.38-.56-6.66-1.26-9.84-2.06Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M340.08,311.39q-3-1.61-5.72-3.38v1.77q2.73,1.74,5.72,3.31Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M367.39,329.42c1.19.23,2.38.46,3.59.66v-1.56c-1.21-.2-2.4-.43-3.59-.66Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M362.14,314.24q4.31,1,8.84,1.79v-1.55c-3-.51-6-1.12-8.84-1.81Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M365.52,318.5c1.79.38,3.61.74,5.46,1V318c-1.85-.31-3.67-.67-5.46-1.05Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M358.14,330.64A119.29,119.29,0,0,0,371,333.48v-1.56a118.74,118.74,0,0,1-12.84-2.86Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M363.14,335.54c2.56.59,5.16,1.13,7.84,1.57v-1.56c-2.68-.45-5.28-1-7.84-1.58Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M337.64,317.05c-1.12-.65-2.22-1.32-3.28-2v1.78c1.06.67,2.16,1.33,3.28,2Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M346.64,318a88.91,88.91,0,0,1-12.28-6.45v1.77a92.61,92.61,0,0,0,12.28,6.33Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M342.58,323a74.82,74.82,0,0,1-8.22-4.57v1.78a81,81,0,0,0,8.22,4.47Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M334.36,323.84a88.17,88.17,0,0,0,17.07,8.29v-1.61a84.89,84.89,0,0,1-17.07-8.46Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M361.58,333.61c-2.9-.73-5.72-1.54-8.44-2.45v1.6c2.72.9,5.54,1.71,8.44,2.42Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M366.8,239.14c-10.65-3.43-19.91-8.13-27.15-13.78v51.69c7.24,5.64,16.5,10.35,27.15,13.78Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.3,291.51l-.65-.21c-10.63-3.42-20.07-8.21-27.31-13.86l-.19-.15v-53l.81.63c7.15,5.58,16.48,10.31,27,13.7l.34.11ZM340.15,276.8a88,88,0,0,0,26.15,13.34V239.51a90.21,90.21,0,0,1-26.15-13.13Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M323.63,197.65V198c0-.1,0-.21,0-.32Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M361.53,277.27a84.89,84.89,0,0,1-17.07-8.46v1.78a88.17,88.17,0,0,0,17.07,8.29Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M361.53,282.4v-1.62a84.89,84.89,0,0,1-17.07-8.46v1.78A88.19,88.19,0,0,0,361.53,282.4Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M361.53,273.76a84.89,84.89,0,0,1-17.07-8.46v1.78a88.17,88.17,0,0,0,17.07,8.29Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M344.46,261.79v1.77a88.19,88.19,0,0,0,17.07,8.3v-1.61A84.89,84.89,0,0,1,344.46,261.79Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M344.46,258.27v1.78a88.19,88.19,0,0,0,17.07,8.3v-1.62A84.37,84.37,0,0,1,344.46,258.27Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M344.46,254.76v1.78a88.17,88.17,0,0,0,17.07,8.29v-1.61A84.89,84.89,0,0,1,344.46,254.76Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M344.46,240.72v1.77a88.19,88.19,0,0,0,17.07,8.3v-1.61A84.89,84.89,0,0,1,344.46,240.72Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M344.46,244.23V246a88.19,88.19,0,0,0,17.07,8.3v-1.61A84.89,84.89,0,0,1,344.46,244.23Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M344.46,247.74v1.78a88.17,88.17,0,0,0,17.07,8.29V256.2A84.89,84.89,0,0,1,344.46,247.74Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M344.46,251.25V253a88.17,88.17,0,0,0,17.07,8.29v-1.61A84.89,84.89,0,0,1,344.46,251.25Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M344.46,235.47a88.17,88.17,0,0,0,17.07,8.29v-1.6a84.37,84.37,0,0,1-17.07-8.46Z",
    transform: "translate(-275.65 -62.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M361.53,247.27v-1.61a84.89,84.89,0,0,1-17.07-8.46V239A87.6,87.6,0,0,0,361.53,247.27Z",
    transform: "translate(-275.65 -62.08)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "244.58 219.66 279.71 212.19 295.6 221.55 292.24 237.53 270.26 244.81 244.58 219.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "61.05 241.27 86.2 235.93 97.57 242.62 95.17 254.06 79.44 259.27 61.05 241.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M335.23,245.18l25.15-5.35s7.25-2.18,10.14,5.91S369.35,258,369.35,258l-15.73,5.21Z",
    transform: "translate(-275.65 -62.08)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.49807a5163417102339b5e2e7e29470c.svg";
export { ForwardRef as ReactComponent };